import I18n from '@js/modules/translations';
import * as Utils from '@js/modules/utils';
import Notification from '@js/components/theme/notification';

import $ from 'jquery';

import 'mapbox.js';
import 'leaflet-fullscreen';
import 'leaflet-responsive-popup';
import 'leaflet.markercluster';
import {
    GestureHandling
} from 'leaflet-gesture-handling';

import {
    getFetch
} from '@js/actions/requests';

import '@js/modules/autoComplete';

import MapInterface from '@js/modules/maps/interface';
import Geolocation from '@js/modules/maps/geolocation';
import Polyline from '@js/modules/maps/polyline';
import leafletPip from '@js/modules/maps/pip';

// import leafletPip from '@mapbox/leaflet-pip';

import '@css/shared/components/_mapbox.scss';


var GlobalMap = (function ($, MapInterface) {
    var globalMap = GlobalMap.prototype;

    var _markerOptions = {
        startMarker: {
            // icon: new L.icon({
            //     iconUrl: `${window.settings.assets_url}/maps/start.png`,
            //     iconSize: [30, 30],
            //     iconAnchor: [15, 30]
            // }),
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/start_marker.png`,
                iconSize: [33, 50],
                iconAnchor: [16, 45]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 900,
            alt: 'Start point'
        },
        // finishMarker: {
        //     icon: new L.icon({
        //         iconUrl: `${window.settings.assets_url}/maps/end.png`,
        //         iconSize: [30, 30],
        //         iconAnchor: [15, 30]
        //     }),
        //     clickable: true,
        //     draggable: false,
        //     opacity: 1,
        //     zIndexOffset: 899,
        //     alt: 'End point'
        // },
        finishHikingMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/hiking_end_marker.png`,
                iconSize: [26, 26],
                iconAnchor: [13, 26]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 899,
            alt: 'End point'
        },
        hikingMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/hiking_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Start point'
        },
        climbingMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/climbing_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Start point'
        },
        cyclingMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/cycling_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Start point'
        },
        visitMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/visit_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Start point'
        },
        walkMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/walk_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Start point'
        },
        poiPointMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/poi_marker.png`,
                iconSize: [30, 30],
                iconAnchor: [15, 30]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 910,
            alt: 'POI point'
        },
        poiHighlightPointMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/poi_highlight_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 920,
            alt: 'POI highlight point'
        },
        poiDirectionMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/direction_straight.png`,
                iconSize: [20, 20],
                iconAnchor: [10, 20]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 909,
            alt: 'POI direction point'
        },
        shopMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/shop_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Shop point'
        },
        terroirMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/shop_terroir_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Shop point'
        },
        artMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/shop_art_marker.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 915,
            alt: 'Shop point'
        },
        touristOfficeMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/tourist_office_marker.png`,
                iconSize: [24, 24],
                iconAnchor: [12, 24]
            }),
            clickable: true,
            draggable: false,
            opacity: 1,
            zIndexOffset: 905,
            alt: 'Toursit office point'
        },
        selectedMarker: {
            icon: new L.divIcon({
                className: 'marker-checked',
                html: '<div class="pin"/>',
                iconSize: [30, 30],
                iconAnchor: [10, 30]
            }),
            zIndexOffset: 920,
            alt: 'Selected point'
        },
        positionMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/edit_end.png`,
                iconSize: [25, 25],
                iconAnchor: [12.5, 12.5]
            }),
            clickable: false,
            draggable: false,
            opacity: 1,
            zIndexOffset: 999,
            alt: 'Position point'
        },
        viewPointMarker: {
            icon: new L.icon({
                iconUrl: `${window.settings.assets_url}/maps/marker-icon.png`,
                shadowUrl: `${window.settings.assets_url}/maps/marker-shadow.png`,
                iconSize: [25, 41],
                iconAnchor: [12, 41]
            }),
            clickable: false,
            draggable: false,
            opacity: 1,
            zIndexOffset: 999,
            alt: 'View point'
        },
        trackPositionMarker: function (angle) {
            return {
                icon: new L.divIcon({
                    className: 'marker-orientation',
                    iconSize: [30, 30],
                    iconAnchor: [30, 30],
                    html: '<div id=\'direction-orientation\' class=\'direction-orientation\' style=\'transform: rotate(' + angle + 'deg)\'><div class=\'direction-center\'/></div>'
                }),
                zIndexOffset: 799
            };
        },
        directionArrow: function (angle) {
            return {
                icon: new L.divIcon({
                    className: 'marker-arrow',
                    iconSize: [30, 30],
                    iconAnchor: [15, 15],
                    html: '<div class=\'direction-arrow\' style=\'transform: rotate(' + angle + 'deg)\'>&#10148;</div>'
                }),
                zIndexOffset: 400
            };
        },
        regionNameMarker: function (name, zoom) {
            var zoomClass = '';
            if (zoom < 6) {
                zoomClass = 'choropleth-label-small';
            } else if (zoom >= 6 && zoom < 8) {
                zoomClass = 'choropleth-label-medium';
            } else if (zoom >= 8) {
                zoomClass = 'choropleth-label-large';
            }

            return {
                icon: new L.divIcon({
                    className: 'choropleth-label ' + zoomClass,
                    html: name,
                    iconSize: [60, 60],
                    iconAnchor: [30, 20]
                })
            };
        }
    };

    var _markerClusterOptions = {
        rideClusters: {
            animate: true,
            showCoverageOnHover: false,
            disableClusteringAtZoom: window.settings.disable_cluster_zoom,
            maxClusterRadius: window.settings.cluster_radius,
            iconCreateFunction: function (cluster) {
                var fontSize = '14';
                if (cluster.getChildCount() > 99) {
                    fontSize = '13';
                }
                return new L.DivIcon({
                    className: 'marker-cluster-hiking',
                    html: '<div class="marker-cluster-number" style="font-size: ' + fontSize + 'px;">' + cluster.getChildCount() + '</div>',
                    iconSize: [30, 30],
                    iconAnchor: [15, 30]
                });
            }
        },
        shopCluster: {
            animate: true,
            showCoverageOnHover: false,
            disableClusteringAtZoom: window.settings.disable_cluster_zoom,
            maxClusterRadius: window.settings.cluster_radius,
            iconCreateFunction: function (cluster) {
                var fontSize = '14';
                if (cluster.getChildCount() > 99) {
                    fontSize = '13';
                }
                return new L.DivIcon({
                    className: 'marker-cluster-shop',
                    html: '<div class="marker-cluster-number" style="font-size: ' + fontSize + 'px;">' + cluster.getChildCount() + '</div>',
                    iconSize: [30, 30],
                    iconAnchor: [15, 30]
                });
            }
        }
    };

    var _polylineOptions = {
        hikingPolyline: {
            'color': '#1a7c96',
            opacity: 0.8
        },
        climbingPolyline: {
            'color': '#1a7c96',
            opacity: 0.8
        },
        cyclingPolyline: {
            'color': '#1a7c96',
            opacity: 0.8
        },
        visitPolyline: {
            'color': '#1a7c96',
            opacity: 0.8
        },
        walkPolyline: {
            'color': '#1a7c96',
            opacity: 0.8
        }
    };

    var _choroplethOptions = {
        franceRegionsUrl: `${window.settings.data_url}/geojson/france/regions.geojson`,
        franceDepartmentsUrl: `${window.settings.data_url}/geojson/france/regions.geojson`,
        franceDepartmentsByRegionUrl: function (regionCode) {
            return `${window.settings.data_url}/geojson/france/regions/${regionCode}/departements.geojson`;
        },
        defaultRegionStyle: {
            weight: 1.5,
            opacity: 0.3,
            color: '#1b7d95',
            fillOpacity: 0.3,
            fillColor: '#edf3da'
        },
        highlightedRegionStyle: {
            weight: 3,
            opacity: 0.6,
            fillOpacity: 0.9
        },
        hoverDepartmentStyle: {
            weight: 4,
            opacity: 0.5,
            fillOpacity: 0.4
        },
        activeRegionStyle: {
            color: '#1b7d95',
            weight: 1,
            fillOpacity: 0.9,
            fillColor: '#f5f5f5'
        },
        inactiveRegionStyle: {
            color: '#1b7d95',
            weight: 1,
            fillOpacity: 0.6,
            fillColor: '#f5f5f5'
        },
        highlightedDepartmentStyle: function (rideCount) {
            var color = rideCount > 50 ? '#8c2d04' :
                rideCount > 30 ? '#cc4c02' :
                    rideCount > 20 ? '#ec7014' :
                        rideCount > 10 ? '#fe9929' :
                            rideCount > 5 ? '#fec44f' :
                                rideCount > 3 ? '#fee391' :
                                    rideCount > 0 ? '#fff7bc' :
                                        '#666';

            // Text color for labels are declared in class .choropleth-label
            return {
                color: '#1b7d95',
                weight: 1.5,
                opacity: 0.3,
                fillOpacity: 0.3,
                fillColor: color
            };
        }
    };

    function GlobalMap(params) {
        var $mapId = $('#' + params.mapId);

        this._model = {
            // Use GeoIP service to get user IP
            geoIP: false,

            // Rides properties
            ridesData: params.ridesData || [],
            hasRideData: true,

            // Shops properties
            shopsData: params.shopsData || [],
            hasShopData: true,

            // map
            map: null,
            styleLayer: null,

            // Mobile
            isTapActivated: false,

            // Map geocoder
            geocoder: null,

            // Geolocation
            geolocationFound: [],
            positionMarker: null,
            directionMarker: null,
            trackPositionMarker: null,
            positionMarkerAngle: 0,
            animationMarker: null,
            $followMeButton: $mapId.find('#follow-me'),

            // container for map
            mapId: params.mapId,

            // params for creation
            initialLocation: params.initialLocation,
            initialZoom: params.initialZoom,

            // bounds provide by user
            mapBounds: null,
            // Reset bounds for a new request
            resetBounds: Utils.isPresent(params.resetBounds) ? params.resetBounds : false,
            // Initial zoom after fit bounds
            initZoom: true,
            // Add to bounds
            includeBounds: Utils.isPresent(params.includeBounds) ? params.includeBounds : null,
            // Detect if zoom comes from fit founds
            isAutoZoom: false,
            // Min zoom after fit bounds
            minZoom: params.minZoom,
            // Default zoom to display the ride
            defaultZoom: 14,

            // Layer containing : start point
            rideClusters: null,

            // Group Ride layers
            rideFeatures: [],

            // km or mi
            distanceUnits: params.distanceUnits || 'km',

            // object for LatLngs by distance traveled (for highcharts hover values)
            pointsByDistanceTraveled: {},

            // show tracks on zoom
            showTrackOnZoom: false,
            // Minimum zoom to display tracks lines
            zoomPolyline: window.settings.min_zoom_polyline,

            // type : ride or shop
            type: params.type,

            // mode : show
            mode: params.mode,

            // Fetch only for the specified ride ids
            rideIds: params.rideIds,
            // Display POIs from these data
            poisData: params.poisData,
            // Highlight one POI in poisData
            poiHighlightId: params.poiHighlightId,
            // Highlight multiple POIs in poisData
            poiHighlightIds: [],
            // Fetch only for the specified shop ids
            shopIds: params.shopIds,
            // Fetch only for the specified shop with products ids
            productIds: params.productIds,
            // Display tourist offices from these data
            touristOfficesData: params.touristOfficesData,
            // Fetch only for the specified shops and rides from the user id
            userId: params.userId,

            // Current ride ids displayed
            rideIdsDisplayed: [],
            // Current shop ids displayed
            shopIdsDisplayed: [],

            // Ride selection mode
            selectedRides: [],

            // Display map style
            $mapStyle: $mapId.find('.map-style-option'),

            // Map search
            hasSearch: Utils.isPresent(params.hasSearch) ? params.hasSearch : true,
            $locationSearchContainer: $mapId.find('.map-search-location'),
            $locationSearchInput: $mapId.find('#location-search-input'),
            $locationSearchButton: $mapId.find('.location-search-button'),

            // Map explore
            hasExplore: Utils.isPresent(params.hasExplore) ? params.hasExplore : false,
            $exploreButton: $mapId.find('#map-explore-search'),

            // Automatically called when map has no visible markers
            exploreSearched: null,

            // Containers for map buttons
            // $styleButtonContainers: $('#' + params.mapId + ' .map-controls-container,' + '#' + params.mapId + ' .specific-points-container'),

            // Storage for bounds, for each user if possible
            storage: '',

            // Force redraw tracks with markers
            redrawAllTracksAndMarkers: false,

            // Current visible elements in view
            visibleElements: [],

            // Updated rides to update
            updatedRideIds: [],

            // Common ride ids with the previous request
            commonRideIds: [],

            // Minimum zoom to show direction arrows
            minZoomDirectionArrow: 16,
            // Direction arrows for the main track
            directionArrows: [],

            // Poi data by ride ids
            poiData: {},
            poiFeatures: {},

            // Shops data
            commonShopIds: [],
            shopFeatures: [],

            // Tourist office data
            touristOfficeFeatures: {},

            // Ride selection mode
            selectedShops: [],

            // Trigger when a marker is clicked
            markerClicked: [],

            // Trigger when a link in a pop-up marker is clicked
            markerLinkClicked: [],

            // Trigger when poi are loaded
            poiLoaded: [],

            // Trigger when poi picture is clicked
            poiImageClicked: [],

            // Search mode
            searchMode: false,

            // Called when visible markers on map has changed
            visibleMarkerCallback: null,

            // Called when a popup is closed on map
            popupCloseCallback: null,

            // Called when affiliated elements are loaded
            affiliatedCallback: null,

            // Called when department click on choropleth mode
            areaClickCallback: null,

            // If a pop-up is already opened
            hasPopup: false,

            // Save previous user zoom
            previousZoom: null,

            // Timer for auto-close popup
            poiPopupOpenTimer: null,
            poiPopupCloseTimer: null,
            selectedPopupTimer: null,

            // Filter requests when fetching
            filter: params.filter || {},

            // Choropleth data
            hasChoropleth: false,
            isChoroplethLoaded: false,
            choroplethLoaded: [],
            regionsLayer: null,
            regionNameMarkers: [],
            regionSelected: null,
            departmentsLayer: null,
            departmentSelected: null,
            densityByDepartments: null,
            choroplethPopup: null,
            $placeContainer: $mapId.find('.map-place-container')
        };

        /* Private Methods
         ******************** */
        this._onMenuClick = function () {
            this._model.$mapStyle
                .on(
                    'mousemove',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                )
                .on(
                    'click',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        var $target = $(event.target);

                        var mapStyleChooser = this._model.$mapStyle.parent()
                            .parent();
                        if (!mapStyleChooser.hasClass('all-options')) {
                            mapStyleChooser.addClass('all-options');
                        } else {
                            if (!$target.hasClass('selected')) {
                                var selectedStyle = $('#' + this._model.mapId + ' .leaflet-control-layers-base input[type="radio"]')
                                    .get($target.attr('data-map-style'));

                                if (selectedStyle && !Array.isArray(selectedStyle)) {
                                    this._model.$mapStyle.removeClass('selected');
                                    selectedStyle.click();
                                    $target.addClass('selected');
                                }
                            }
                            mapStyleChooser.removeClass('all-options');
                        }
                    }.bind(this)
                );

            this._model.$locationSearchInput.off('focus')
                .off('blur')
                .off('keypress')
                .on(
                    'mousemove',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                )
                .on(
                    'keypress',
                    function (event) {
                        var code = (event.keyCode ? event.keyCode : event.which);

                        if (code === 13) {
                            if (Utils.isEmpty(this._model.$locationSearchInput.data('selected-bounds')) &&
                                Utils.isEmpty(this._model.$locationSearchInput.data('selected-location'))) {
                                MapInterface.searchForLocation(
                                    {
                                        term: this._model.$locationSearchInput.val(),
                                        mapCenter: this._model.map.getCenter()
                                    },
                                    function (resultMap) {
                                        if (resultMap && resultMap.compact().length > 0) {
                                            this._model.$locationSearchInput.data('selected-bounds', resultMap[0].bounds);
                                            this._model.$locationSearchInput.data('selected-location', resultMap[0].location);
                                            this._goToSearchLocation();
                                        } else {
                                            Notification.alert(I18n.t('js.maps.search.no_results'));
                                        }
                                    }.bind(this));
                            } else {
                                this._goToSearchLocation();
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }.bind(this))
            ;

            this._model.$locationSearchButton.off('click')
                .on(
                    'mousemove',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                )
                .on(
                    'click touchend',
                    function () {
                        MapInterface.searchForLocation(
                            {
                                term: this._model.$locationSearchInput.val(),
                                mapCenter: this._model.map.getCenter()
                            },
                            function (resultMap) {
                                if (resultMap) {
                                    resultMap = resultMap.compact();
                                    this._model.$locationSearchInput.data('selected-bounds', resultMap[0].bounds);
                                    this._model.$locationSearchInput.data('selected-location', resultMap[0].location);
                                    this._goToSearchLocation();
                                }
                            }.bind(this));
                    }.bind(this));

            this._model.$exploreButton.hide();
            this._model.$exploreButton.off('click')
                .on(
                    'click touchend',
                    function (event) {
                        if (this._model.exploreSearched) {
                            event.preventDefault();
                            event.stopPropagation();

                            var bounds = this._model.map.getBounds();
                            var mapBounds = [bounds._southWest.lat, bounds._southWest.lng, bounds._northEast.lat, bounds._northEast.lng].reverse();
                            var center = bounds.getCenter();
                            var mapCenter = [center.lat, center.lng];

                            this._model.exploreSearched(mapBounds, mapCenter);
                        }
                    }.bind(this)
                );
        };

        this._stopClickPropagation = function () {
            this._model.$styleButtonContainers
                .on(
                    'click dblclick touchend',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                );
        };

        this._highlightPoi = function (poiId, rideId) {
            if (!poiId) {
                return;
            }

            this._model.poiHighlightId = poiId;
            this._drawPois(rideId);
        };

        this._removePoiMarkersPoints = function (rideId) {
            if (!!rideId && !!this._model.poiFeatures[rideId]) {
                if (this._model.poiFeatures[rideId].markerPoints) {
                    for (var i = 0; i < this._model.poiFeatures[rideId].markerPoints.length; i++) {
                        this._model.map.removeLayer(this._model.poiFeatures[rideId].markerPoints[i].marker);
                    }
                }

                this._model.poiFeatures[rideId].markerPoints = [];
            }
        };

        this._drawPois = function (rideId) {
            if (!rideId || !this._model.poiFeatures[rideId]) {
                return;
            }

            var poiMarkerInfos = this._model.poiFeatures[rideId].markerInfos;
            var poiMarkerPoint;
            var poiMarkerInfo;
            var poiMarkerData;

            if (Utils.isEmpty(poiMarkerInfos)) {
                console.error('Empty set of poi for this ride, return.');
                return;
            }

            // Clear old POI markers
            this._removePoiMarkersPoints(rideId);

            // Draw POI markers
            if (poiMarkerInfos.length > 0) {
                for (var poiMarkerIndex = 0; poiMarkerIndex < poiMarkerInfos.length; poiMarkerIndex++) {
                    poiMarkerInfo = poiMarkerInfos[poiMarkerIndex];

                    var markerType = _markerOptions.poiPointMarker;
                    if (poiMarkerInfo.data.status === 'direction') {
                        markerType = _markerOptions.poiDirectionMarker;
                    } else if (this._model.poiHighlightId === poiMarkerInfo.data.id || this._model.poiHighlightIds.includes(poiMarkerInfo.data.id)) {
                        markerType = _markerOptions.poiHighlightPointMarker;
                    }
                    var newMarkerPoint = new MapInterface.MarkerPoint(
                        new L.marker(
                            new L.latLng(poiMarkerInfo.latLng.lat, poiMarkerInfo.latLng.lng),
                            markerType
                        ),
                        poiMarkerInfo.data.id
                    );

                    if (newMarkerPoint) {
                        // add to map
                        newMarkerPoint.marker.addTo(this._model.map);

                        // add to array for reference
                        this._model.poiFeatures[rideId].markerPoints.push(newMarkerPoint);

                        // set up event handlers
                        this._addMarkersPointEventHandlers('poi', newMarkerPoint, poiMarkerInfo);
                    }
                }
            }

            if (this._model.type === globalMap.type.POI) {
                return;
            }

            // Draw pop-up
            if (poiMarkerInfos.length > 0) {
                for (var m = 0; m < poiMarkerInfos.length; m++) {
                    poiMarkerPoint = this._model.poiFeatures[rideId].markerPoints[m];
                    poiMarkerInfo = poiMarkerInfos[m];
                    poiMarkerData = poiMarkerInfos[m].data;

                    var popupContent = document.createElement('div');
                    popupContent.className = 'slideshow-popup';
                    // if (poiMarkerData.pictures.length > 0) {
                    //     popupContent.onclick = this._poiImageClickedFuncs.bind(this, poiMarkerData, 0);
                    // }

                    if (poiMarkerData.pictures.length > 0) {
                        var slideShowContent = document.createElement('div');
                        for (var i = 0; i < poiMarkerData.pictures.length; i++) {
                            var picture = poiMarkerData.pictures[i];

                            if (picture.mediumUrl && picture.mediumUrl.jpg) {
                                var imageContainer = document.createElement('div');
                                imageContainer.className = 'image';
                                if (i === 0) {
                                    imageContainer.className += ' active';
                                }

                                var imageContent = document.createElement('img');
                                imageContent.src = picture.mediumUrl.jpg;
                                imageContent.onclick = function (poiMarkerDataInfo, index, event) {
                                    event.preventDefault();

                                    if (this._model.map.isFullscreen()) {
                                        this._model.map.toggleFullscreen();
                                    }

                                    this._poiImageClickedFuncs(poiMarkerDataInfo, index);
                                }.bind(this, poiMarkerData, i);

                                imageContainer.appendChild(imageContent);
                                slideShowContent.appendChild(imageContainer);
                            }
                        }

                        var slideShow = document.createElement('div');
                        slideShow.className = 'slideshow';
                        slideShow.appendChild(slideShowContent);
                        popupContent.appendChild(slideShow);

                        if (poiMarkerData.pictures.length > 1) {
                            var slideShowNavigation = document.createElement('div');
                            slideShowNavigation.className = 'cycle';
                            slideShowNavigation.innerHTML =
                                '<a href="#" class="prev">' + I18n.t('js.maps.slideshow.previous') + '</a>' +
                                '<a href="#" class="next">' + I18n.t('js.maps.slideshow.next') + '</a>';
                            slideShowNavigation.onclick = function (event) {
                                event.preventDefault();

                                var $slideShow = $(slideShow);
                                var $newSlide;

                                if ($(this)
                                    .hasClass('prev')) {
                                    $newSlide = $slideShow.find('.active')
                                        .prev();
                                    if ($newSlide.index() < 0) {
                                        $newSlide = $('.image')
                                            .last();
                                    }
                                } else {
                                    $newSlide = $slideShow.find('.active')
                                        .next();
                                    if ($newSlide.index() < 0) {
                                        $newSlide = $('.image')
                                            .first();
                                    }
                                }

                                $slideShow.find('.active')
                                    .removeClass('active')
                                    .hide();
                                $newSlide.addClass('active')
                                    .show();

                                return false;
                            }.bind(this);
                            popupContent.appendChild(slideShowNavigation);
                        }
                    }

                    if (poiMarkerData.summary || (poiMarkerData.description && poiMarkerData.pictures.length > 0)) {
                        var summary = document.createElement('p');
                        summary.className = 'poi-summary';
                        summary.innerHTML = poiMarkerData.summary;
                        popupContent.appendChild(summary);
                    }

                    if (poiMarkerData.description) {
                        if (poiMarkerData.pictures.length === 0) {
                            var description = document.createElement('div');
                            description.className = 'poi-description';
                            description.innerHTML = poiMarkerData.description;
                            popupContent.appendChild(description);
                        } else {
                            var moreDescription = document.createElement('i');
                            moreDescription.className = 'material-icons poi-description-more';
                            moreDescription.innerHTML = 'add_circle';
                            moreDescription.onclick = function () {
                                window.open(poiMarkerData.link, '_self');
                            }.bind(this);
                            summary.appendChild(moreDescription);
                        }
                    }

                    var responsivePopup = L.responsivePopup({hasTip: true})
                        .setContent(popupContent);

                    var poiPopup = poiMarkerPoint.marker.bindPopup(responsivePopup,
                        {
                            closeButton: false,
                            offset: [0, -20],
                            className: poiMarkerInfo.type + '-popup'
                        });

                    // Display pop-up on mouse hover
                    this._model.poiPopupOpenTimer = null;
                    this._model.poiPopupCloseTimer = null;

                    poiPopup.on('mouseover', function (event) {
                        this._model.poiPopupOpenTimer = setTimeout(function () {
                            event.target.openPopup();
                            this._model.hasPopup = true;
                            if (this._model.poiPopupCloseTimer) {
                                clearTimeout(this._model.poiPopupCloseTimer);
                            }
                        }.bind(this), 300);
                    }.bind(this));

                    poiPopup.on('mouseout', function (event) {
                        if (this._model.poiPopupOpenTimer) {
                            clearTimeout(this._model.poiPopupOpenTimer);
                        }

                        if (this._model.hasPopup) {
                            this._model.poiPopupCloseTimer = setTimeout(function () {
                                event.target.closePopup();
                                this._model.hasPopup = false;
                            }.bind(this), 2000);
                        }
                    }.bind(this));

                    poiPopup.on('click', function (event) {
                        event.target.openPopup();
                        this._model.hasPopup = true;
                    }.bind(this));
                }
            }
        };

        // Options:
        // secondary: affiliated markers with less importance
        this._drawShops = function (options) {
            if (Utils.isEmpty(this._model.shopsData) || window.seoMode) {
                // Empty set of shops
                return;
            }

            var shopIndex;
            var previousShopId;
            var currentShopId;
            var currentShopIds = [];
            var previousShopFeatures = this._model.shopFeatures;

            this._model.commonShopIds = [];
            this._model.shopFeatures = [];

            for (shopIndex = 0; shopIndex < this._model.shopsData.length; shopIndex++) {
                currentShopIds.push(this._model.shopsData[shopIndex].id);
            }

            for (shopIndex = 0; shopIndex < previousShopFeatures.length; shopIndex++) {
                previousShopId = previousShopFeatures[shopIndex].shopId;

                if (currentShopIds.indexOf(previousShopId) !== -1) {
                    this._model.commonShopIds.push(previousShopId);
                    this._model.shopFeatures.push(previousShopFeatures[shopIndex]);
                } else {
                    // Remove marker layer
                    if (Utils.isPresent(previousShopFeatures[shopIndex].shopLayer)) {
                        previousShopFeatures[shopIndex].shopLayer.clearLayers();
                    }
                    // Remove cluster layer
                    this._model.shopClusters.removeLayer(previousShopFeatures[shopIndex].shopMarker);
                }
            }

            for (shopIndex = 0; shopIndex < this._model.shopsData.length; shopIndex++) {
                if (Utils.isEmpty(this._model.shopsData[shopIndex])) {
                    continue;
                }

                currentShopId = this._model.shopsData[shopIndex].id;

                // Element doesn't exists
                if (this._model.commonShopIds.indexOf(currentShopId) === -1) {
                    var currentShopFeature = {};
                    currentShopFeature.shopLayer = new L.FeatureGroup();

                    currentShopFeature.shopId = this._model.shopsData[shopIndex].shopId || this._model.shopsData[shopIndex].id;
                    currentShopFeature.trade = this._model.shopsData[shopIndex].trade;
                    currentShopFeature.name = this._model.shopsData[shopIndex].name;
                    currentShopFeature.summary = this._model.shopsData[shopIndex].summary;
                    currentShopFeature.notation = this._model.shopsData[shopIndex].notation;
                    currentShopFeature.defaultPicture = this._model.shopsData[shopIndex].defaultPicture;
                    currentShopFeature.city = this._model.shopsData[shopIndex].city;
                    currentShopFeature.linkUrl = this._model.shopsData[shopIndex].link;

                    if (this._model.mode === globalMap.mode.AFFILIATING) {
                        if (this._model.selectedShops.indexOf(currentShopFeature.shopId) > -1) {
                            currentShopFeature.linkName = I18n.t('js.maps.marker.shop.unaffiliating');
                        } else {
                            currentShopFeature.linkName = I18n.t('js.maps.marker.shop.affiliating');
                        }
                    } else {
                        currentShopFeature.linkName = I18n.t('js.maps.marker.shop.details');
                    }

                    var shopLatitude,
                        shopLongitude;

                    if (this._model.shopsData[shopIndex].coordinates) {
                        shopLatitude = this._model.shopsData[shopIndex].coordinates[0];
                        shopLongitude = this._model.shopsData[shopIndex].coordinates[1];
                    } else {
                        shopLatitude = this._model.shopsData[shopIndex].latitude;
                        shopLongitude = this._model.shopsData[shopIndex].longitude;
                    }

                    currentShopFeature.shopPoint = new MapInterface.PointInfo(L.latLng(shopLatitude, shopLongitude), 0, 0, null);

                    this._model.shopFeatures.push(currentShopFeature);
                }
            }

            for (shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                currentShopId = this._model.shopFeatures[shopIndex].shopId;

                var shopMarkerOptions = _markerOptions.shopMarker;

                if (this._model.selectedShops.indexOf(currentShopId) > -1) {
                    shopMarkerOptions = _markerOptions.selectedMarker;
                }

                if (this._model.commonShopIds.indexOf(currentShopId) === -1) {
                    // if (this._model.shopFeatures[shopIndex].trade === 'terroir') {
                    //    this._model.shopFeatures[shopIndex].shopMarker = new L.marker(this._model.shopFeatures[shopIndex].shopPoint.latLng, _markerOptions.terroirMarker);
                    // } else if (this._model.shopFeatures[shopIndex].trade === 'art') {
                    //    this._model.shopFeatures[shopIndex].shopMarker = new L.marker(this._model.shopFeatures[shopIndex].shopPoint.latLng, _markerOptions.artMarker);
                    // } else {
                    if (options && options.secondary) {
                        shopMarkerOptions.opacity = 0.75;
                    }
                    this._model.shopFeatures[shopIndex].shopMarker = new L.marker(this._model.shopFeatures[shopIndex].shopPoint.latLng, shopMarkerOptions);
                    // }

                    if (this._model.shopClusters && this._model.shopFeatures[shopIndex].shopMarker && this._model.shopFeatures[shopIndex].shopMarker._latlng) {
                        this._model.shopClusters.addLayer(this._model.shopFeatures[shopIndex].shopMarker);
                        this._model.shopFeatures[shopIndex].shopLayer.addLayer(this._model.shopFeatures[shopIndex].shopMarker);
                        this._model.shopClusters.addTo(this._model.map);
                    }

                    // set up event handlers
                    if (this._model.mode !== globalMap.mode.EXPLORE) {
                        this._addMarkersPointEventHandlers('shop', this._model.shopFeatures[shopIndex]);
                    }
                }
            }

            if (this._model.mode === globalMap.mode.SHOW ||
                (this._model.mode === globalMap.mode.AFFILIATED && this._model.type === globalMap.type.SHOP) ||
                (this._model.mode === globalMap.mode.AFFILIATING && this._model.type === globalMap.type.SHOP)) {
                return;
            }

            for (shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                var shopId = this._model.shopFeatures[shopIndex].shopId;
                var shopLinkUrl = this._model.shopFeatures[shopIndex].linkUrl;
                var shopLinkName = this._model.shopFeatures[shopIndex].linkName;
                var defaultPicture = this._model.shopFeatures[shopIndex].defaultPicture?.mini?.jpg;

                var popupContent = document.createElement('a');
                popupContent.href = shopLinkUrl;
                // popupContent.target = '_blank';
                popupContent.className = 'marker-info-box';

                if (!!defaultPicture) {
                    var imageContainer = document.createElement('div');
                    imageContainer.className = 'image';
                    var imageContent = document.createElement('img');
                    imageContent.src = defaultPicture;
                    imageContainer.appendChild(imageContent);
                    popupContent.appendChild(imageContainer);
                }

                var popupDetails = document.createElement('div');
                popupDetails.className = 'popup-details';

                var title = document.createElement('h3');
                title.innerHTML = this._model.shopFeatures[shopIndex].name;
                popupDetails.appendChild(title);

                // var summary = document.createElement('p');
                // summary.innerHTML = this._model.shopFeatures[shopIndex].summary;
                // popupContent.appendChild(summary);
                //
                // var clear = document.createElement('div');
                // clear.className = 'clearfix';
                // popupContent.appendChild(clear);
                //
                // var prop = document.createElement('div');
                // prop.className = 'prop';
                // popupContent.appendChild(prop);
                //
                // var shopSpeciality = this._model.shopFeatures[shopIndex].speciality;
                // var speciality = document.createElement('div');
                // speciality.className = 'stat';
                // speciality.innerHTML = '<strong>' + shopSpeciality + '</strong>';
                // prop.appendChild(speciality);
                //
                // var shopNotation = this._model.shopFeatures[shopIndex].notation;
                // var notation = document.createElement('ul');
                // notation.className = 'list-inline star-vote pull-right';
                // for (star = 1; star <= shopNotation; star++) {
                //     notation.innerHTML += '<li><i class="color-yellow fa fa-star"></i></li>';
                // }
                // for (star = shopNotation; star < 5; star++) {
                //     notation.innerHTML += '<li><i class="color-yellow fa fa-star-o"></i></li>';
                // }
                // prop.appendChild(notation);
                //
                // var link = document.createElement('div');
                // link.className = 'details-link';
                //
                // if (this._model.type === globalMap.type.SELECTED || this._model.mode === globalMap.mode.AFFILIATING) {
                //     link.innerHTML += '<a class="button" href="#">' + shopLinkName + '</a>';
                //     link.onclick = this._markerLinkClickedFuncs.bind(this, 'shop', shopId, shopLinkUrl);
                // } else {
                //     link.innerHTML += '<a class="button" href="' + shopLinkUrl + '">' + shopLinkName + '</a>';
                // }
                // popupDetails.appendChild(link);

                var link;
                if (this._model.type === globalMap.type.SELECTED ||
                    this._model.mode === globalMap.mode.CHOROPLETH) {
                    link = document.createElement('div');
                    link.className = 'marker-link';
                    link.innerHTML += '<a class="marker-link-button" target="_blank" href="' + shopLinkUrl + '"><i class="material-icons">add_circle</i></a>';
                    popupDetails.appendChild(link);
                }

                if (this._model.mode === globalMap.mode.AFFILIATING) {
                    link = document.createElement('div');
                    link.className = 'details-link';
                    link.innerHTML += '<a class="button" href="#">' + shopLinkName + '</a>';
                    link.onclick = this._markerLinkClickedFuncs.bind(this, 'shop', shopId, shopLinkUrl);

                    popupDetails.appendChild(link);
                }

                popupContent.appendChild(popupDetails);

                var responsivePopup = L.responsivePopup({hasTip: true})
                    .setContent(popupContent);

                var shopPopup = this._model.shopFeatures[shopIndex].shopMarker.bindPopup(responsivePopup,
                    {
                        closeButton: false,
                        offset: [0, -20],
                        'className': 'shop-popup'
                    });

                this._model.selectedPopupTimer = null;

                if (this._model.type === globalMap.type.SELECTED) {
                    shopPopup.on('mouseover', function (event) {
                        if (this._model.map.getZoom() > 13) {
                            event.target.openPopup();
                            this._model.hasPopup = true;
                            if (this._model.selectedPopupTimer) {
                                clearTimeout(this._model.selectedPopupTimer);
                            }
                        }
                    }.bind(this));

                    shopPopup.on('mouseout', function (event) {
                        if (this._model.hasPopup && this._model.map.getZoom() > 13) {
                            this._model.selectedPopupTimer = setTimeout(function () {
                                event.target.closePopup();
                                this._model.hasPopup = false;
                            }.bind(this), 1800);
                        }
                    }.bind(this));

                    shopPopup.on('click', function (shopId, event) {
                        this._markerClickedFuncs('shop', shopId);
                        this._model.hasPopup = true;
                    }.bind(this, shopId));
                }
            }
        };


        this._removeTouristOfficeMarkersPoints = function () {
            if (!!this._model.touristOfficeFeatures.markerPoints) {
                if (this._model.touristOfficeFeatures) {
                    for (var i = 0; i < this._model.touristOfficeFeatures.markerPoints.length; i++) {
                        this._model.map.removeLayer(this._model.touristOfficeFeatures[i].markerPoints.marker);
                    }
                }
            }

            this._model.touristOfficeFeatures.markerPoints = [];
        };


        this._drawTouristOffices = function () {
            if (Utils.isEmpty(this._model.touristOfficeFeatures) || Utils.isEmpty(this._model.touristOfficeFeatures.markerInfos)) {
                console.error('Empty set of tourist offices, return.');
                return;
            }

            // Clear old POI markers
            this._removeTouristOfficeMarkersPoints();

            // Draw POI markers
            if (this._model.touristOfficeFeatures.markerInfos.length > 0) {
                for (var touristOfficeMarkerIndex = 0; touristOfficeMarkerIndex < this._model.touristOfficeFeatures.markerInfos.length; touristOfficeMarkerIndex++) {
                    var touristOfficeMarker = this._model.touristOfficeFeatures.markerInfos[touristOfficeMarkerIndex];

                    var markerType = _markerOptions.touristOfficeMarker;
                    var newMarkerPoint = new MapInterface.MarkerPoint(
                        new L.marker(
                            new L.latLng(touristOfficeMarker.latLng.lat, touristOfficeMarker.latLng.lng),
                            markerType
                        ),
                        touristOfficeMarker.data.id
                    );

                    if (newMarkerPoint) {
                        // add to map
                        newMarkerPoint.marker.addTo(this._model.map);

                        // add to array for reference
                        this._model.touristOfficeFeatures.markerPoints.push(newMarkerPoint);
                    }
                }
            }

            if (this._model.type === globalMap.type.TOURIST_OFFICE) {
                return;
            }

            if (this._model.touristOfficeFeatures.markerInfos.length > 0) {
                for (var m = 0; m < this._model.touristOfficeFeatures.markerInfos.length; m++) {
                    var touristOfficeMarkerPoint = this._model.touristOfficeFeatures.markerPoints[m];
                    var touristOfficeMarkerData = this._model.touristOfficeFeatures.markerInfos[m].data;

                    touristOfficeMarkerPoint.marker.on('click', function (touristOfficeMarkerData, event) {
                        window.open(touristOfficeMarkerData.link, '_blank');
                    }.bind(this, touristOfficeMarkerData));
                }
            }

            // // Draw pop-up
            // if (this._model.touristOfficeFeatures.markerInfos.length > 0) {
            //     for (var m = 0; m < this._model.touristOfficeFeatures.markerInfos.length; m++) {
            //         var touristOfficeMarkerPoint = this._model.touristOfficeFeatures.markerPoints[m];
            //         var poiMarkerInfo = this._model.touristOfficeFeatures.markerInfos[m];
            //         var touristOfficeMarkerData = this._model.touristOfficeFeatures.markerInfos[m].data;
            //
            //         var popupContent = document.createElement('div');
            //         popupContent.className = 'slideshow-popup';
            //         // if (touristOfficeMarkerData.pictures.length > 0) {
            //         //     popupContent.onclick = this._poiImageClickedFuncs.bind(this, touristOfficeMarkerData, 0);
            //         // }
            //
            //         if (touristOfficeMarkerData.pictures.length > 0) {
            //             var slideShowContent = document.createElement('div');
            //             for (var i = 0; i < touristOfficeMarkerData.pictures.length; i++) {
            //                 var picture = touristOfficeMarkerData.pictures[i];
            //
            //                 if (picture.mediumUrl) {
            //                     var imageContainer = document.createElement('div');
            //                     imageContainer.className = 'image';
            //                     if (i === 0) {
            //                         imageContainer.className += ' active';
            //                     }
            //
            //                     var imageContent = document.createElement('img');
            //                     imageContent.src = picture.mediumUrl.jpg;
            //                     imageContent.onclick = this._poiImageClickedFuncs.bind(this, touristOfficeMarkerData, i);
            //
            //                     imageContainer.appendChild(imageContent);
            //                     slideShowContent.appendChild(imageContainer);
            //                 }
            //             }
            //
            //             var slideShow = document.createElement('div');
            //             slideShow.className = 'slideshow';
            //             slideShow.appendChild(slideShowContent);
            //             popupContent.appendChild(slideShow);
            //
            //             if (touristOfficeMarkerData.pictures.length > 1) {
            //                 var slideShowNavigation = document.createElement('div');
            //                 slideShowNavigation.className = 'cycle';
            //                 slideShowNavigation.innerHTML =
            //                     '<a href="#" class="prev">' + I18n.t('js.maps.slideshow.previous') + '</a>' +
            //                     '<a href="#" class="next">' + I18n.t('js.maps.slideshow.next') + '</a>';
            //                 slideShowNavigation.onclick = function (event) {
            //                     event.preventDefault();
            //
            //                     var $slideShow = $(slideShow), $newSlide;
            //
            //                     if ($(this).hasClass('prev')) {
            //                         $newSlide = $slideShow.find('.active').prev();
            //                         if ($newSlide.index() < 0) {
            //                             $newSlide = $('.image').last();
            //                         }
            //                     } else {
            //                         $newSlide = $slideShow.find('.active').next();
            //                         if ($newSlide.index() < 0) {
            //                             $newSlide = $('.image').first();
            //                         }
            //                     }
            //
            //                     $slideShow.find('.active').removeClass('active').hide();
            //                     $newSlide.addClass('active').show();
            //
            //                     return false;
            //                 };
            //                 popupContent.appendChild(slideShowNavigation);
            //             }
            //         }
            //
            //         if (touristOfficeMarkerData.summary || (touristOfficeMarkerData.description && touristOfficeMarkerData.pictures.length > 0)) {
            //             var summary = document.createElement('p');
            //             summary.className = 'poi-summary';
            //             summary.innerHTML = touristOfficeMarkerData.summary;
            //             popupContent.appendChild(summary);
            //         }
            //
            //         if (touristOfficeMarkerData.description) {
            //             if (touristOfficeMarkerData.pictures.length === 0) {
            //                 var description = document.createElement('div');
            //                 description.className = 'poi-description';
            //                 description.innerHTML = touristOfficeMarkerData.description;
            //                 popupContent.appendChild(description);
            //             } else {
            //                 var moreDescription = document.createElement('i');
            //                 moreDescription.className = 'material-icons poi-description-more';
            //                 moreDescription.innerHTML = 'add_circle';
            //                 moreDescription.onclick = this._poiImageClickedFuncs.bind(this, touristOfficeMarkerData, 0);
            //                 summary.appendChild(moreDescription);
            //             }
            //         }
            //
            //         var poiPopup = touristOfficeMarkerPoint.marker.bindPopup(popupContent,
            //             {
            //                 closeButton: true,
            //                 offset: [0, -20],
            //                 'className': poiMarkerInfo.type + '-popup'
            //             });
            //
            //         // Display pop-up on mouse hover
            //         this._model.poiPopupCloseTimer = null;
            //
            //         poiPopup.on('mouseover', function (event) {
            //             event.target.openPopup();
            //             this._model.hasPopup = true;
            //             if (this._model.poiPopupCloseTimer) {
            //                 clearTimeout(this._model.poiPopupCloseTimer);
            //             }
            //         }.bind(this));
            //
            //         poiPopup.on('mouseout', function (event) {
            //             if (this._model.hasPopup) {
            //                 this._model.poiPopupCloseTimer = setTimeout(function () {
            //                     event.target.closePopup();
            //                     this._model.hasPopup = false;
            //                 }.bind(this), 1800);
            //             }
            //         }.bind(this));
            //
            //         poiPopup.on('click', function (event) {
            //             event.target.openPopup();
            //             this._model.hasPopup = true;
            //         }.bind(this));
            //     }
            // }
        };

        // Options:
        // secondary: affiliated markers with less importance
        this._drawTracksAndMarkers = function (options) {
            if (window.seoMode) {
                return;
            }

            // establish key points to edit with
            this._setupTracks();

            // draw markers
            this._redrawMarkers(options);

            // draw trip polyline, add to map
            this._redrawTracks();

            // draw direction arrows
            this._drawDirectionArrows();

            // Display pop-up on click
            this._markerPopup();
        };

        this._forceRedrawTracksAndMarkers = function () {
            this._model.redrawAllTracksAndMarkers = true;

            this._clearRideClusterMarkers();
            this._clearTracks();
            this._model.rideFeatures = [];

            this._drawTracksAndMarkers();
            this._model.redrawAllTracksAndMarkers = false;
        };

        this._fitMapBounds = function () {
            // get the map bounds by looking at all polylines involved
            if (this._model.mapBounds !== null || window.seoMode) {
                return;
            }

            var bounds = new L.LatLngBounds();

            // Fit to polylines or clusters
            if (this._model.rideFeatures.length > 0) {
                for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                    bounds = bounds.extend(this._model.rideFeatures[rideIndex].markerLayer.getBounds());
                    if (this._model.rideFeatures[rideIndex].polylineLayer) {
                        bounds = bounds.extend(this._model.rideFeatures[rideIndex].polylineLayer.getBounds());
                    }
                }
            }

            if (this._model.shopFeatures.length > 0) {
                for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                    bounds = bounds.extend(this._model.shopFeatures[shopIndex].shopLayer.getBounds());
                }
            }

            if (this._model.positionMarker) {
                bounds = bounds.extend(this._model.positionMarker._latlng);
            }

            if (this._model.poisData) {
                for (var rideId in this._model.poiFeatures) {
                    if (this._model.poiFeatures.hasOwnProperty(rideId)) {
                        for (var i = 0; i < this._model.poiFeatures[rideId].markerInfos.length; i++) {
                            var markerInfo = this._model.poiFeatures[rideId].markerInfos[i];
                            bounds = bounds.extend(markerInfo.latLng);
                        }
                    }
                }
            }

            if (this._model.touristOfficeFeatures.markerInfos) {
                for (var touristOfficeIndex = 0; touristOfficeIndex < this._model.touristOfficeFeatures.markerInfos.length; touristOfficeIndex++) {
                    bounds = bounds.extend(this._model.touristOfficeFeatures.markerInfos[touristOfficeIndex].latLng);
                }
            }

            if (Utils.isPresent(this._model.includeBounds) && this._model.includeBounds.length === 4) {
                var bbox = [
                    [
                        parseFloat(this._model.includeBounds[1]),
                        parseFloat(this._model.includeBounds[0])
                    ],
                    [
                        parseFloat(this._model.includeBounds[3]),
                        parseFloat(this._model.includeBounds[2])
                    ]
                ];
                bounds = bounds.extend(bbox);
            }

            // fit to the overall bounds
            if (Utils.isPresent(bounds) && bounds.isValid()) {
                this._model.mapBounds = bounds.pad(0.2);
                this._model.isAutoZoom = true;
                this._model.map.fitBounds(this._model.mapBounds);
                this._model.isAutoZoom = false;
            }

            // Set minimum zoom
            if (this._model.map.getZoom() > (this._model.minZoom || 14)) {
                this._model.map.setZoom(this._model.minZoom || 14);
            } else {
                // Cannot do this now: map not yet fitted
                // Zoom up to see markers
                // this._model.map.setZoom(this._model.map.getZoom() - 1);
            }
        };

        this._fitMapBoundsByMode = function () {
            if (this._model.mode === globalMap.mode.AFFILIATED) {
                // var bounds = new L.LatLngBounds();
                //
                // if (this._model.type === globalMap.type.RIDE) {
                //     if (this._model.rideFeatures.length > 0) {
                //         for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                //             bounds = bounds.extend(this._model.rideFeatures[rideIndex].markerLayer.getBounds());
                //             if (this._model.rideFeatures[rideIndex].polylineLayer) {
                //                 bounds = bounds.extend(this._model.rideFeatures[rideIndex].polylineLayer.getBounds());
                //             }
                //         }
                //     }
                // } else if (this._model.type === globalMap.type.SHOP) {
                //     if (this._model.shopFeatures.length > 0) {
                //         for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                //             bounds = bounds.extend(this._model.shopFeatures[shopIndex].shopLayer.getBounds());
                //         }
                //     }
                // }

                // fit to the overall bounds
                if (Utils.isPresent(this._model.mapBounds)) {
                    this._model.isAutoZoom = true;
                    this._model.map.fitBounds(this._model.mapBounds);
                    this._model.isAutoZoom = false;
                }
            } else if (this._model.type === globalMap.type.SELECTED) {
                if (this._isFetchFinished()) {
                    // this._model.mapBounds = null;
                    this._fitMapBounds();
                    // this._updateVisibleMarkers();
                }
            } else {
                this._fitMapBounds();
            }
        };

        this._isFetchFinished = function () {
            if (this._model.type === globalMap.type.SELECTED) {
                var hasAllData = true;

                if (Utils.isPresent(this._model.rideIds)) {
                    hasAllData = this._model.hasRideData;
                }
                if (Utils.isPresent(this._model.shopIds)) {
                    hasAllData = this._model.hasShopData;
                }
                if (Utils.isPresent(this._model.userId)) {
                    hasAllData = this._model.hasRideData && this._model.hasShopData;
                }

                return hasAllData;
            } else {
                return true;
            }
        };

        this._saveMapBounds = function (bounds) {
            if (localStorage) {
                localStorage.setItem(this._model.storage, JSON.stringify(bounds));
            }
        };

        this._getCurrentMapPosition = function () {
            var mapCenter = null;
            var mapZoom = null;

            if (Utils.isPresent(this._model.initialLocation)) {
                if (Utils.isPresent(this._model.initialLocation.center)) {
                    this._model.initialLat = parseFloat(this._model.initialLocation.center[1]);
                    this._model.initialLong = parseFloat(this._model.initialLocation.center[0]);
                } else {
                    this._model.initialLat = parseFloat(this._model.initialLocation[0]);
                    this._model.initialLong = parseFloat(this._model.initialLocation[1]);
                }

                if (this._model.initialLat && this._model.initialLong) {
                    mapCenter = new L.latLng(this._model.initialLat, this._model.initialLong);
                    mapZoom = this._model.initialZoom || this._model.defaultZoom;
                }
            } else if (Utils.isPresent(this._model.initialLat) && Utils.isPresent(this._model.initialLong)) {
                this._model.initialLat = parseFloat(this._model.initialLat);
                this._model.initialLong = parseFloat(this._model.initialLong);

                mapCenter = new L.latLng(this._model.initialLat, this._model.initialLong);
                mapZoom = this._model.initialZoom || this._model.defaultZoom;
            }

            if (Utils.isPresent(mapCenter) && Utils.isPresent(mapZoom)) {
                return {
                    center: mapCenter,
                    zoom: mapZoom
                };
                // } else if (window.currentCountry === 'en-us') {
                //     return {
                //         center: MapInterface.usaCenter,
                //         zoom: MapInterface.usaZoom
                //     };
                // } else if (window.currentCountry === 'fr') {
                //     return {
                //         center: MapInterface.franceCenter,
                //         zoom: MapInterface.franceZoom
                //     };
                // } else if (window.currentCountry === 'de') {
                //     return {
                //         center: MapInterface.germanyCenter,
                //         zoom: MapInterface.germanyZoom
                //     };
                // } else if (window.currentCountry === 'it') {
                //     return {
                //         center: MapInterface.italyCenter,
                //         zoom: MapInterface.italyZoom
                //     };
            } else {
                return {
                    center: MapInterface.franceCenter,
                    zoom: MapInterface.franceZoom
                };
            }
        };

        this._getSavedMapBounds = function () {
            var bounds;

            if (localStorage && this._model.storage !== '') {
                bounds = JSON.parse(localStorage.getItem(this._model.storage));
            }

            if (Utils.isPresent(bounds)) {
                return L.latLngBounds(L.latLng(bounds._southWest), L.latLng(bounds._northEast));
            }
        };

        this._setupTracks = function () {
            if (Utils.isEmpty(this._model.ridesData)) {
                // Empty set of tracks
                return;
            }

            var trackIndex;
            var previousRideId;
            var currentRideId;
            var trackPolyline;
            var lineTracksPoints;
            var trackCoord;
            var newEncodedPolyline;
            var newRideIds = [];
            var newPolylines = {};
            var previousRideFeatures = this._model.rideFeatures;

            this._model.commonRideIds = [];
            this._model.rideFeatures = [];

            if (!this._model.redrawAllTracksAndMarkers) {
                for (trackIndex = 0; trackIndex < this._model.ridesData.length; trackIndex++) {
                    newRideIds.push(this._model.ridesData[trackIndex].id);
                    newPolylines[this._model.ridesData[trackIndex].id] = this._model.ridesData[trackIndex].encodedPolyline || this._model.ridesData[trackIndex].simplifiedPolyline;
                }

                for (trackIndex = 0; trackIndex < previousRideFeatures.length; trackIndex++) {
                    previousRideId = previousRideFeatures[trackIndex].rideId;

                    if (newRideIds.indexOf(previousRideId) !== -1) {
                        // Clear polyline if we don't display anymore the polyline

                        if (this._model.map.getZoom() < this._model.zoomPolyline && Utils.isPresent(previousRideFeatures[trackIndex].polylineLayer)) {
                            if (Utils.isPresent(previousRideFeatures[trackIndex].polylineLayer)) {
                                previousRideFeatures[trackIndex].polylineLayer.clearLayers();
                                previousRideFeatures[trackIndex].polylineLayer = null;
                            }
                        } else {
                            // Save the new polyline
                            previousRideFeatures[trackIndex].linePoints = [];
                            newEncodedPolyline = newPolylines[previousRideFeatures[trackIndex].rideId];
                            if (Utils.isPresent(newEncodedPolyline)) {
                                // Decode polyline to convert in [lat, lng] format
                                trackPolyline = Polyline.decode(newEncodedPolyline, 5);
                                lineTracksPoints = [];
                                for (trackCoord = 0; trackCoord < trackPolyline.length; trackCoord++) {
                                    lineTracksPoints.push(
                                        new MapInterface.PointInfo(
                                            L.latLng(trackPolyline[trackCoord][0], trackPolyline[trackCoord][1]),
                                            0,
                                            0,
                                            null
                                        )
                                    );
                                }

                                if (lineTracksPoints.length > 0) {
                                    previousRideFeatures[trackIndex].linePoints = lineTracksPoints;
                                }
                            }
                        }

                        this._model.commonRideIds.push(previousRideId);
                        this._model.rideFeatures.push(previousRideFeatures[trackIndex]);
                    } else {
                        // Remove polyline layer
                        if (Utils.isPresent(previousRideFeatures[trackIndex].polylineLayer)) {
                            previousRideFeatures[trackIndex].polylineLayer.clearLayers();
                        }

                        // Remove cluster layer
                        if (this._model.rideClusters && previousRideFeatures[trackIndex].startMarker) {
                            this._model.rideClusters.removeLayer(previousRideFeatures[trackIndex].startMarker);
                        }

                        // // Remove marker layer
                        if (Utils.isPresent(previousRideFeatures[trackIndex].markerLayer)) {
                            previousRideFeatures[trackIndex].markerLayer.clearLayers();
                        }
                    }
                }
            }

            for (trackIndex = 0; trackIndex < this._model.ridesData.length; trackIndex++) {
                if (Utils.isEmpty(this._model.ridesData[trackIndex])) {
                    continue;
                }

                currentRideId = this._model.ridesData[trackIndex].id;

                // Element doesn't exists
                if (this._model.commonRideIds.indexOf(currentRideId) === -1) {
                    var currentTrackFeature = {};
                    currentTrackFeature.linePoints = [];
                    currentTrackFeature.markerLayer = new L.FeatureGroup();
                    currentTrackFeature.polylineLayer = null;

                    currentTrackFeature.rideId = this._model.ridesData[trackIndex].rideId || this._model.ridesData[trackIndex].id;
                    currentTrackFeature.name = this._model.ridesData[trackIndex].name;
                    currentTrackFeature.summary = this._model.ridesData[trackIndex].summary;
                    currentTrackFeature.defaultPicture = this._model.ridesData[trackIndex].defaultPicture?.mini?.jpg;
                    currentTrackFeature.formattedDistance = this._model.ridesData[trackIndex].formattedDistance;
                    currentTrackFeature.formattedDuration = this._model.ridesData[trackIndex].formattedDuration;
                    currentTrackFeature.city = this._model.ridesData[trackIndex].city;
                    currentTrackFeature.linkUrl = this._model.ridesData[trackIndex].link;
                    currentTrackFeature.linkName = I18n.t('js.maps.marker.ride.details');

                    if (this._model.mode === globalMap.mode.AFFILIATING) {
                        if (this._model.selectedRides.indexOf(currentTrackFeature.rideId) > -1) {
                            currentTrackFeature.linkName = I18n.t('js.maps.marker.ride.unaffiliating');
                        } else {
                            currentTrackFeature.linkName = I18n.t('js.maps.marker.ride.affiliating');
                        }
                    }

                    currentTrackFeature.type = this._model.ridesData[trackIndex].type.toLowerCase();
                    currentTrackFeature.distance = this._model.ridesData[trackIndex].distance;
                    currentTrackFeature.duration = this._model.ridesData[trackIndex].duration;
                    currentTrackFeature.level = this._model.ridesData[trackIndex].level;
                    currentTrackFeature.notation = this._model.ridesData[trackIndex].notation;

                    currentTrackFeature.linePoints = [];
                    newEncodedPolyline = this._model.ridesData[trackIndex].encodedPolyline || this._model.ridesData[trackIndex].simplifiedPolyline;
                    if (Utils.isPresent(newEncodedPolyline)) {
                        // Decode polyline to convert in [lat, lng] format
                        trackPolyline = Polyline.decode(newEncodedPolyline, 5);
                        lineTracksPoints = [];
                        for (trackCoord = 0; trackCoord < trackPolyline.length; trackCoord++) {
                            lineTracksPoints.push(
                                new MapInterface.PointInfo(
                                    L.latLng(trackPolyline[trackCoord][0], trackPolyline[trackCoord][1]),
                                    0,
                                    0,
                                    null
                                )
                            );
                        }

                        if (lineTracksPoints.length > 0) {
                            currentTrackFeature.linePoints = lineTracksPoints;
                        }
                    }

                    this._model.rideFeatures.push(currentTrackFeature);
                }
            }

            // Update ride features if ride update
            for (trackIndex = 0; trackIndex < this._model.ridesData.length; trackIndex++) {
                if (Utils.isPresent(this._model.ridesData[trackIndex])) {
                    currentRideId = this._model.ridesData[trackIndex].id;
                    if (this._model.updatedRideIds.indexOf(currentRideId) !== -1) {
                        var updatedTrackFeature = this._model.rideFeatures.filter(function (feature) {
                            return feature.rideId === currentRideId;
                        })
                            .first();
                        updatedTrackFeature.distance = this._model.ridesData[trackIndex].distance;
                        updatedTrackFeature.duration = this._model.ridesData[trackIndex].duration;
                        updatedTrackFeature.level = this._model.ridesData[trackIndex].level;
                        updatedTrackFeature.notation = this._model.ridesData[trackIndex].notation;
                        this._model.rideFeatures = this._model.rideFeatures.replace('rideId', updatedTrackFeature);
                    }
                }
            }
        };

        this._redrawMarkers = function (options) {
            var linePoints;
            var startLinePoint;
            var currentRideId;
            var rideType;
            var markerOption;

            for (var trackIndex = 0; trackIndex < this._model.rideFeatures.length; trackIndex++) {
                linePoints = this._model.rideFeatures[trackIndex].linePoints;

                if (linePoints.length > 0) {
                    startLinePoint = linePoints[0];

                    currentRideId = this._model.rideFeatures[trackIndex].rideId;

                    if ((this._model.commonRideIds.indexOf(currentRideId) === -1 && this._model.updatedRideIds.indexOf(currentRideId) === -1) ||
                        this._model.redrawAllTracksAndMarkers) {
                        if (this._model.type === globalMap.type.SHOP) {
                            rideType = this._model.rideFeatures[trackIndex].type;
                            markerOption = _markerOptions[rideType + 'Marker'];
                            if (options && options.secondary) {
                                markerOption.opacity = 0.75;
                            }
                            startLinePoint.keyPoint = new L.marker(startLinePoint.latLng, markerOption);

                            if (this._model.selectedRides.indexOf(currentRideId) > -1) {
                                startLinePoint.keyPoint = new L.marker(startLinePoint.latLng, _markerOptions.selectedMarker);
                            }

                            if (this._model.rideClusters) {
                                this._model.rideClusters.addLayer(startLinePoint.keyPoint);
                            }
                        } else {
                            rideType = this._model.rideFeatures[trackIndex].type;
                            markerOption = _markerOptions[rideType + 'Marker'];
                            startLinePoint.keyPoint = new L.marker(startLinePoint.latLng, markerOption);
                            if (this._model.rideClusters) {
                                this._model.rideClusters.addLayer(startLinePoint.keyPoint);
                            }
                        }

                        this._model.rideFeatures[trackIndex].startMarker = startLinePoint.keyPoint;
                        this._model.rideFeatures[trackIndex].markerLayer.addLayer(startLinePoint.keyPoint);

                        // set up event handlers
                        if (this._model.mode !== globalMap.mode.EXPLORE) {
                            this._addMarkersPointEventHandlers('ride', this._model.rideFeatures[trackIndex]);
                        }
                    }
                }

                if (this._model.rideClusters) {
                    this._model.rideClusters.addTo(this._model.map);
                }
            }
        };

        this._clearAll = function () {
            this._clearRideClusterMarkers();
            this._clearTracks();
            this._clearPoiMarkers();
            this._model.ridesData = [];
            this._model.rideFeatures = [];
            this._model.poiFeatures = [];

            this._clearShops();
            this._model.shopsData = [];
            this._model.shopFeatures = [];
        };

        this._clearRideClusterMarkers = function () {
            if (this._model.rideClusters) {
                this._model.rideClusters.clearLayers();
            }
        };

        this._clearTracks = function () {
            for (var trackIndex = 0; trackIndex < this._model.rideFeatures.length; trackIndex++) {
                this._model.rideFeatures[trackIndex].markerLayer.clearLayers();
                if (Utils.isPresent(this._model.rideFeatures[trackIndex].polylineLayer)) {
                    this._model.rideFeatures[trackIndex].polylineLayer.clearLayers();
                }
            }

            this._model.rideFeatures = [];
        };

        this._clearPoiMarkers = function () {
            if (this._model.poiFeatures) {
                Object.keys(this._model.poiFeatures)
                    .forEach(function (rideId) {
                        var poiFeature = this._model.poiFeatures[rideId];
                        if (poiFeature) {
                            if (poiFeature.markerPoints) {
                                for (var i = 0; i < poiFeature.markerPoints.length; i++) {
                                    this._model.map.removeLayer(poiFeature.markerPoints[i].marker);
                                }
                            }
                            poiFeature.markerPoints = [];
                            poiFeature.markerInfos = [];
                        }
                    }.bind(this));
            }
        };

        this._clearShops = function () {
            for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                this._model.shopFeatures[shopIndex].shopLayer.clearLayers();
            }

            this._model.shopFeatures = [];

            if (this._model.shopClusters) {
                this._model.shopClusters.clearLayers();
            }
        };

        this._redrawTracks = function () {
            if (((this._model.mode === globalMap.mode.EXPLORE || this._model.mode === globalMap.mode.CHOROPLETH) &&
                (this._model.map.getZoom() < this._model.zoomPolyline || this._model.rideFeatures.length === 0))) {
                return;
            }

            var linePoints;

            for (var trackIndex = 0; trackIndex < this._model.rideFeatures.length; trackIndex++) {
                if (this._model.commonRideIds.indexOf(this._model.rideFeatures[trackIndex].rideId) === -1 ||
                    Utils.isEmpty(this._model.rideFeatures[trackIndex].polylineLayer) ||
                    this._model.rideFeatures[trackIndex].linePoints.length === 2) {
                    linePoints = this._model.rideFeatures[trackIndex].linePoints;

                    if (linePoints.length < 3) {
                        continue;
                    }

                    this._model.rideFeatures[trackIndex].polylineLayer = new L.FeatureGroup();

                    // set initial 'total Distance' variable
                    var totalDistance = 0;

                    // what distance marker we are currently on
                    var markerCount = 0;

                    var thisLegDist = 0;

                    // draw this line segment
                    var nextLine = [];
                    for (var pointIndex = 0; pointIndex <= linePoints.length - 1; pointIndex++) {
                        nextLine.push(linePoints[pointIndex].latLng);

                        var thisLinePointLatLng = linePoints[pointIndex].latLng;
                        var prevLinePointLatLng;

                        if (pointIndex !== 0) {
                            prevLinePointLatLng = linePoints[pointIndex - 1].latLng;
                            thisLegDist = Utils.flooredNum(MapInterface.distHaversine(prevLinePointLatLng, thisLinePointLatLng), 6);
                            totalDistance = Utils.flooredNum(totalDistance + thisLegDist, 6);
                        }

                        // handle the total distance stamp for Highcharts point mapping
                        var traveledDistance = totalDistance;
                        if (this._model.distanceUnits === 'mi') {
                            traveledDistance /= Utils.distanceFunctions.KM_PER_MILE;
                        }

                        if (this._model.mode !== globalMap.mode.EXPLORE && this._model.mode !== globalMap.mode.CHOROPLETH) {
                            this._model.pointsByDistanceTraveled[Math.floor(traveledDistance)] = thisLinePointLatLng;
                        }

                        // Are we 1 distance unit (or more) greater? try to draw a distance marker
                        var curDist = traveledDistance / 1000;
                        if (curDist >= markerCount + 1) {
                            var markersToAdd = Math.floor(curDist) - markerCount;
                            for (var k = 0; k < markersToAdd; k++) {
                                // kick marker number
                                markerCount++;

                                // if zoomed in far enough, show all individual mile markers
                                // if not zoomed in past 13, show every 5 if at 12
                                // if not zoomed in past 12, show every 10 if at 11
                                if ((this._model.map.getZoom() >= 13) ||
                                    ((this._model.map.getZoom() >= 12) && (markerCount % 5 === 0)) ||
                                    ((this._model.map.getZoom() >= 11) && markerCount % 10 === 0)) {
                                    // find lat lng
                                    var distanceToDistMarker = markerCount - curDist;
                                    var percentageDist;
                                    if (this._model.distanceUnits === 'mi') {
                                        percentageDist = distanceToDistMarker / (thisLegDist / 1000 / Utils.distanceFunctions.KM_PER_MILE);
                                    } else {
                                        percentageDist = distanceToDistMarker / (thisLegDist / 1000);
                                    }
                                }
                            }
                        }
                    }

                    // draw lines on map in the set color
                    var rideType = this._model.rideFeatures[trackIndex].type;
                    var thisLine = new L.polyline(nextLine, _polylineOptions[rideType + 'Polyline']);
                    this._model.rideFeatures[trackIndex].polylineLayer.addLayer(thisLine);

                    // Add end marker
                    var endLinePoint = linePoints[linePoints.length - 1];
                    endLinePoint.keyPoint = new L.marker(endLinePoint.latLng, _markerOptions.finishHikingMarker);
                    this._model.rideFeatures[trackIndex].polylineLayer.addLayer(endLinePoint.keyPoint);

                    // By default, show polyline only if there are few rides
                    if (this._model.rideIds && this._model.rideIds.length < 10) {
                        this._model.map.addLayer(this._model.rideFeatures[trackIndex].polylineLayer);
                    }

                    // set up event handlers but not for updated rides
                    if (this._model.updatedRideIds.indexOf(this._model.rideFeatures[trackIndex].rideId) === -1) {
                        this._addMarkersPointEventHandlers('ride', this._model.rideFeatures[trackIndex]);
                    }

                    // // Instead, show polyline on click
                    // this._model.rideFeatures[trackIndex].startMarker.on('click', L.bind(this._markerOnClick.bind(this), null, this._model.rideFeatures[trackIndex].polylineLayer));
                }
            }
        };

        this._getZoomDictionary = function (zoomLevel) {
            if (zoomLevel >= 17) {
                return {
                    directionArrow: 200
                };
            } else if (zoomLevel === 16) {
                return {
                    directionArrow: 200
                };
            } else if (zoomLevel === 15) {
                return {
                    directionArrow: 300
                };
            } else if (zoomLevel === 14) {
                return {
                    directionArrow: 500
                };
            } else if (zoomLevel === 13 || zoomLevel === 12) {
                return {
                    directionArrow: 750
                };
            } else if (zoomLevel < 12) {
                return {
                    directionArrow: 1000
                };
            } else {
                return {
                    directionArrow: 1000
                };
            }
        };

        this._removeDirectionArrows = function () {
            for (var i = 0; i < this._model.directionArrows.length; i++) {
                if (this._model.map.hasLayer(this._model.directionArrows[i].marker)) {
                    this._model.map.removeLayer(this._model.directionArrows[i].marker);
                }
            }
            this._model.directionArrows = [];
        };

        this._drawDirectionArrows = function () {
            this._removeDirectionArrows();

            if (this._model.mode === globalMap.mode.EXPLORE ||
                this._model.mode === globalMap.mode.CHOROPLETH ||
                this._model.map.getZoom() < this._model.minZoomDirectionArrow ||
                this._model.rideFeatures.length === 0) {
                return;
            }

            if (this._model.type === globalMap.type.RIDE && this._model.rideFeatures.length === 1) {
                var currentTrack = this._model.rideFeatures[0].linePoints;
                if (currentTrack.length < 3) {
                    return;
                }

                // draw a fake point in between every key point to allow user to insert a new point here.
                // variable for distance since last direction arrow
                var distanceSinceLastDirectionArrow = 0;

                // how often SHOULD we be placing direction arrows?
                var directionArrowInterval = this._getZoomDictionary(this._model.map.getZoom()).directionArrow;

                // after placing a direction arrow, how much distance is left over (so we can place correctly after the next invisible point)
                var carryoverDistance = 0;
                var lastKeyPointIndex = 0;
                for (var j = 0; j < currentTrack.length; j++) {
                    var thisLinePoint;
                    var prevLinePoint;
                    thisLinePoint = currentTrack[j];

                    // variable for point-to-point distance
                    var distanceBetween = 0;
                    if (j > 0) {
                        prevLinePoint = currentTrack[j - 1];
                        distanceBetween = MapInterface.distHaversine(prevLinePoint.latLng, thisLinePoint.latLng);
                        distanceSinceLastDirectionArrow += distanceBetween;
                    }

                    // if we've traveled more than the direction arrow interval, find out how many to place
                    var directionArrowsToPlace = 0;
                    if (distanceSinceLastDirectionArrow > directionArrowInterval) {
                        directionArrowsToPlace = Math.floor(distanceSinceLastDirectionArrow / directionArrowInterval);
                    }

                    // start with carryover distance
                    // move from point A to point B, placing direction arrows at interval specified (remove carryover from last loop iteration)
                    // when done, set carryover distance and continue
                    if (directionArrowsToPlace > 0) {
                        for (var k = 1; k <= directionArrowsToPlace; k++) {
                            var directionArrowLat;
                            var directionArrowLng;
                            var distanceToNextDirectionArrow = (directionArrowInterval * k) - carryoverDistance;
                            var percentageBetweenPoints = distanceToNextDirectionArrow / distanceBetween;

                            // we now know at what percentage distance the direction arrow should be placed. Use to put it on the line
                            directionArrowLat = prevLinePoint.latLng.lat + ((thisLinePoint.latLng.lat - prevLinePoint.latLng.lat) * percentageBetweenPoints);
                            directionArrowLng = prevLinePoint.latLng.lng + ((thisLinePoint.latLng.lng - prevLinePoint.latLng.lng) * percentageBetweenPoints);

                            // correct arrow shifting
                            directionArrowLat -= 0.00008;

                            var diffLat = thisLinePoint.latLng.lat - prevLinePoint.latLng.lat;
                            var diffLng = thisLinePoint.latLng.lng - prevLinePoint.latLng.lng;
                            // var center = [thisLinePoint.latLng.lat + diffLat / 2, thisLinePoint.latLng.lng + diffLng / 2];
                            var angle = (360 - ((Math.atan2(diffLat, diffLng) * 57.295779513082) % 360));

                            // create direction arrow object
                            var newDirectionArrow = new MapInterface.DirectionArrow(
                                new L.marker(
                                    new L.latLng(directionArrowLat, directionArrowLng),
                                    _markerOptions.directionArrow(angle + this._model.positionMarkerAngle)
                                ),
                                lastKeyPointIndex
                            );

                            // add to map
                            newDirectionArrow.marker.addTo(this._model.map);

                            // add to array for reference
                            this._model.directionArrows.push(newDirectionArrow);

                            if (k === directionArrowsToPlace) {
                                // last need
                                carryoverDistance = distanceBetween - (percentageBetweenPoints * distanceBetween);
                                distanceSinceLastDirectionArrow = carryoverDistance;
                            }
                        }
                    } else {
                        carryoverDistance += distanceBetween;
                    }

                    if (thisLinePoint.keyPoint != null) {
                        lastKeyPointIndex = j;
                    }
                }
            }
        };

        this._addMarkersPointEventHandlers = function (type, markerFeature, markerInfo) {
            if (type === 'ride') {
                markerFeature.startMarker.off('mouseover')
                    .off('mouseout')
                    .off('drag')
                    .off('dragstart')
                    .off('dragend')
                    .off('contextmenu')
                    .on(
                        'click',
                        function () {
                            if (this._model.mode === globalMap.mode.AFFILIATED) {
                                if (this._model.type === globalMap.type.RIDE) {
                                    return;
                                }

                                if (this._model.map.getZoom() >= this._model.zoomPolyline) {
                                    // Fetch ride POIs and polyline on click if zoom is enough
                                    var polylineLayer = markerFeature.polylineLayer;

                                    if (polylineLayer && this._model.map.hasLayer(polylineLayer)) {
                                        markerFeature.startMarker.closePopup();
                                        this._model.map.removeLayer(polylineLayer);
                                        this._removePoiMarkersPoints(markerFeature.rideId);
                                    } else {
                                        this.fetchCompleteRides({
                                            rideIds: [markerFeature.rideId],
                                            update: true
                                        }, function () {
                                            markerFeature.startMarker.closePopup();
                                            markerFeature.startMarker.openPopup();

                                            if (polylineLayer && !this._model.map.hasLayer(polylineLayer)) {
                                                this._model.map.addLayer(polylineLayer);
                                            }

                                            // Marker event is set twice, reset it
                                            markerFeature.startMarker.off('click');
                                            this._addMarkersPointEventHandlers(type, markerFeature);

                                            this._model.mapBounds = null;
                                            this._fitMapBounds();
                                        }.bind(this));

                                        this.fetchPOI(markerFeature.rideId);
                                    }
                                }
                            }

                            this._model.hasPopup = !this._model.hasPopup;

                            this._markerClickedFuncs(type, markerFeature.rideId);
                        }.bind(this)
                    );
            } else if (type === 'poi') {
                markerFeature.marker.off('mouseover')
                    .off('mouseout')
                    .off('drag')
                    .off('dragstart')
                    .off('dragend')
                    .off('contextmenu')
                    .on(
                        'click',
                        function () {
                            if (this._model.mode === globalMap.mode.SHOW) {
                                window.open(markerInfo.data.link, '_self');
                            }
                        }.bind(this)
                    );
            } else if (type === 'shop') {
                markerFeature.shopMarker.off('mouseover')
                    .off('mouseout')
                    .off('drag')
                    .off('dragstart')
                    .off('dragend')
                    .off('contextmenu')
                    .on(
                        'click',
                        function () {
                            if (this._model.mode === globalMap.mode.AFFILIATING) {
                                if (this._model.type === globalMap.type.SHOP) {
                                    return;
                                }
                            }

                            this._markerClickedFuncs(type, markerFeature.shopId);
                        }.bind(this));
            }
        };

        this._markerPopup = function () {
            if (this._model.mode === globalMap.mode.AFFILIATING && this._model.type === globalMap.type.RIDE) {
                return;
            }

            for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                var rideId = this._model.rideFeatures[rideIndex].rideId;
                var rideName = this._model.rideFeatures[rideIndex].name;
                var rideLinkUrl = this._model.rideFeatures[rideIndex].linkUrl;
                var rideLinkName = this._model.rideFeatures[rideIndex].linkName;
                var rideType = this._model.rideFeatures[rideIndex].type;
                var defaultPicture = this._model.rideFeatures[rideIndex].defaultPicture;
                var responsivePopup;

                if (this._model.type === globalMap.type.SELECTED ||
                    this._model.mode === globalMap.mode.EXPLORE ||
                    this._model.mode === globalMap.mode.CHOROPLETH) {
                    var popupContent = document.createElement('a');
                    popupContent.href = rideLinkUrl;
                    // popupContent.target = '_blank';
                    popupContent.className = 'marker-info-box';

                    if (!!defaultPicture) {
                        var imageContainer = document.createElement('div');
                        imageContainer.className = 'image';
                        var imageContent = document.createElement('img');
                        imageContent.src = defaultPicture;
                        imageContainer.appendChild(imageContent);
                        popupContent.appendChild(imageContainer);
                    }

                    var popupDetails = document.createElement('div');
                    popupDetails.className = 'popup-details';

                    var title = document.createElement('h3');
                    title.innerHTML = rideName;
                    popupDetails.appendChild(title);

                    var link = document.createElement('div');
                    link.className = 'marker-link';
                    link.innerHTML += '<a class="marker-link-button"  target="_blank" href="' + rideLinkUrl + '"><i class="material-icons">add_circle</i></a>';
                    popupDetails.appendChild(link);

                    popupContent.appendChild(popupDetails);

                    if (this._model.rideFeatures[rideIndex].startMarker) {
                        responsivePopup = L.responsivePopup({hasTip: true})
                            .setContent(popupContent);

                        var ridePopup = this._model.rideFeatures[rideIndex].startMarker.bindPopup(responsivePopup,
                            {
                                closeButton: false,
                                offset: [0, -20],
                                className: rideType + '-popup'
                            });

                        this._model.selectedPopupTimer = null;

                        ridePopup.on('mouseover', function (event) {
                            if (this._model.map.getZoom() > 13) {
                                event.target.openPopup();
                                this._model.hasPopup = true;
                                if (this._model.selectedPopupTimer) {
                                    clearTimeout(this._model.selectedPopupTimer);
                                }
                            }
                        }.bind(this));

                        ridePopup.on('mouseout', function (event) {
                            if (this._model.hasPopup && this._model.map.getZoom() > 13) {
                                this._model.selectedPopupTimer = setTimeout(function () {
                                    event.target.closePopup();
                                    this._model.hasPopup = false;
                                }.bind(this), 1800);
                            }
                        }.bind(this));

                        ridePopup.on('click', function (currentRideId, event) {
                            event.target.openPopup();

                            this._markerClickedFuncs('ride', currentRideId);

                            this._model.hasPopup = true;
                        }.bind(this, rideId));
                    }
                } else if (this._model.mode === globalMap.mode.AFFILIATING) {
                    var affiliatingPopupContent = document.createElement('a');
                    affiliatingPopupContent.href = rideLinkUrl;
                    // affiliatingPopupContent.target = '_blank';
                    affiliatingPopupContent.className = 'marker-info-box';

                    var affiliatingPopupDetails = document.createElement('div');
                    affiliatingPopupDetails.className = 'popup-details';

                    var affiliatingTitle = document.createElement('h3');
                    affiliatingTitle.innerHTML = rideName;
                    affiliatingPopupDetails.appendChild(affiliatingTitle);

                    var affiliatingLink = document.createElement('div');
                    affiliatingLink.className = 'details-link';
                    affiliatingLink.innerHTML += '<a class="button" href="#">' + rideLinkName + '</a>';
                    affiliatingLink.onclick = this._markerLinkClickedFuncs.bind(this, 'ride', rideId, rideLinkUrl);

                    affiliatingPopupDetails.appendChild(affiliatingLink);

                    affiliatingPopupContent.appendChild(affiliatingPopupDetails);

                    if (this._model.rideFeatures[rideIndex].startMarker) {
                        var affiliatingPopup = this._model.rideFeatures[rideIndex].startMarker.bindPopup(affiliatingPopupContent,
                            {
                                closeButton: true,
                                offset: [0, -20],
                                'className': rideType + '-popup'
                            });

                        affiliatingPopup.on('click', function (event) {
                            event.target.openPopup();
                            this._model.hasPopup = true;
                        }.bind(this));
                    }
                } else if (this._model.mode === globalMap.mode.AFFILIATED) {
                    var startPopupContent = document.createElement('div');
                    startPopupContent.href = rideLinkUrl;
                    // startPopupContent.target = '_blank';
                    startPopupContent.className = 'marker-info-box marker-start';

                    var startPopupDetails = document.createElement('div');
                    startPopupDetails.className = 'popup-details';

                    var startTitle = document.createElement('h3');
                    startTitle.innerHTML = I18n.t('js.maps.marker.ride.start', {name: rideName});
                    startPopupDetails.appendChild(startTitle);

                    startPopupContent.appendChild(startPopupDetails);

                    responsivePopup = L.responsivePopup({hasTip: true})
                        .setContent(startPopupContent);

                    if (this._model.rideFeatures[rideIndex].startMarker) {
                        this._model.rideFeatures[rideIndex].startMarker.bindPopup(responsivePopup,
                            {
                                closeButton: false,
                                offset: [0, -20],
                                'className': rideType + '-popup'
                            });
                    }

                    // var endPopupContent = document.createElement('div');
                    // endPopupContent.href = rideLinkUrl;
                    // endPopupContent.className = 'marker-info-box marker-end';
                    //
                    // var endPopupDetails = document.createElement('div');
                    // endPopupDetails.className = 'popup-details';
                    //
                    // var endTitle = document.createElement('h3');
                    // endTitle.innerHTML =  I18n.t('js.maps.marker.ride.end');
                    // endPopupDetails.appendChild(endTitle);
                    //
                    // endPopupContent.appendChild(endPopupDetails);
                    //
                    // var endPopup = this._model.rideFeatures[rideIndex].endMarker.bindPopup(endPopupContent,
                    //     {
                    //         closeButton: true,
                    //         offset: [0, -20],
                    //         'className': rideType + '-popup'
                    //     });
                }
            }
        };

        this._markerClickedFuncs = function (type, markerId) {
            for (var i = 0, n = this._model.markerClicked.length; i < n; i++) {
                this._model.markerClicked[i](type, markerId);
            }
        };

        this._markerLinkClickedFuncs = function (type, markerId, url, event) {
            event.preventDefault();

            for (var i = 0, n = this._model.markerLinkClicked.length; i < n; i++) {
                this._model.markerLinkClicked[i](type, markerId, url);
            }
        };

        this._poiLoadedFuncs = function (rideId, poisData) {
            for (var i = 0, n = this._model.poiLoaded.length; i < n; i++) {
                this._model.poiLoaded[i](rideId, poisData);
            }
        };

        this._poiImageClickedFuncs = function (poiData, pictureIndex) {
            for (var i = 0, n = this._model.poiImageClicked.length; i < n; i++) {
                this._model.poiImageClicked[i](poiData, pictureIndex);
            }
        };

        this._choroplethLoadedFuncs = function () {
            for (var i = 0, n = this._model.choroplethLoaded.length; i < n; i++) {
                this._model.choroplethLoaded[i]();
            }
        };

        this._geolocatedFuncs = function (mode, positionLocated) {
            for (var i = 0, n = this._model.geolocationFound.length; i < n; i++) {
                this._model.geolocationFound[i](mode, positionLocated);
            }
        };

        this._updateVisibleMarkers = function (options) {
            if (this._model.visibleMarkerCallback) {
                var visibleElements = [];
                var mapBounds = this._model.map.getBounds();

                if (this._model.rideFeatures.length > 0) {
                    for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                        if (Utils.isPresent(this._model.rideFeatures[rideIndex].markerLayer.getBounds()) &&
                            mapBounds.contains(this._model.rideFeatures[rideIndex].markerLayer.getBounds())) {
                            var rideFeature = this._model.rideFeatures[rideIndex];
                            visibleElements.push({
                                type: 'ride',
                                id: rideFeature.rideId,
                                name: rideFeature.name,
                                link: rideFeature.linkUrl
                            });
                        }
                    }
                }

                if (this._model.shopFeatures.length > 0) {
                    for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                        if (Utils.isPresent(this._model.shopFeatures[shopIndex].shopLayer.getBounds()) &&
                            mapBounds.contains(this._model.shopFeatures[shopIndex].shopLayer.getBounds())) {
                            var shopFeature = this._model.shopFeatures[shopIndex];
                            visibleElements.push({
                                type: 'shop',
                                id: shopFeature.shopId,
                                name: shopFeature.name,
                                link: shopFeature.linkUrl
                            });
                        }
                    }
                }

                // Map explore mode: always perform a new search when map is drag or zoom, except for zoom up
                if (this._model.hasExplore &&
                    this._model.exploreSearched &&
                    (!options || (options && !options.initData)) &&
                    this._model.map.getZoom() < this._model.previousZoom
                    /* && visibleElements.length === 0*/) {
                    // If no visible elements on map, run explore callback
                    var bounds = [mapBounds._southWest.lat, mapBounds._southWest.lng, mapBounds._northEast.lat, mapBounds._northEast.lng].reverse();
                    var center = mapBounds.getCenter();
                    var mapCenter = [center.lat, center.lng];

                    this._model.exploreSearched(bounds, mapCenter);

                    // this._model.$exploreButton.show({duration: 400});
                    // } else {
                    //     this._model.$exploreButton.hide({duration: 400});
                }

                if (!visibleElements.isEqualIds(this._model.visibleElements)) {
                    this._model.visibleElements = visibleElements;
                    this._model.visibleMarkerCallback(this._model.visibleElements);
                }
            }
        };

        this._popupClosed = function () {
            if (this._model.popupCloseCallback) {
                this._model.popupCloseCallback();
            }
        };

        this._updateAffiliatedElements = function (type) {
            if (this._model.affiliatedCallback) {
                var affiliatedElements = [];

                if (type === 'ride' && this._model.rideFeatures.length > 0) {
                    for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                        var rideFeature = this._model.rideFeatures[rideIndex];
                        affiliatedElements.push({
                            type: 'ride',
                            id: rideFeature.rideId,
                            name: rideFeature.name,
                            summary: rideFeature.summary,
                            defaultPicture: rideFeature.defaultPicture,
                            formattedDistance: rideFeature.formattedDistance,
                            formattedDuration: rideFeature.formattedDuration,
                            city: rideFeature.city,
                            link: rideFeature.linkUrl
                        });
                    }
                }

                if (type === 'shop' && this._model.shopFeatures.length > 0) {
                    for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                        var shopFeature = this._model.shopFeatures[shopIndex];
                        affiliatedElements.push({
                            type: 'shop',
                            id: shopFeature.shopId,
                            trade: shopFeature.trade,
                            tradeTranslated: I18n.t(`js.shop.enums.trade.${shopFeature.trade}`),
                            name: shopFeature.name,
                            summary: shopFeature.summary,
                            defaultPicture: shopFeature.defaultPicture,
                            link: shopFeature.linkUrl
                        });
                    }
                }

                this._model.affiliatedCallback(type, affiliatedElements);
            }
        };

        this._fetchRequired = function (doneCallback) {
            var options = {};

            if (this._model.type === globalMap.type.RIDE) {
                if (Utils.isPresent(this._model.rideIds)) {
                    options.rideIds = this._model.rideIds;
                }
                if (Utils.isPresent(this._model.filter)) {
                    options.filter = this._model.filter;
                }

                if (this._model.mode === globalMap.mode.SHOW ||
                    this._model.mode === globalMap.mode.AFFILIATED ||
                    this._model.mode === globalMap.mode.AFFILIATING) {
                    this.fetchCompleteRides(options, function () {
                        if (typeof (doneCallback) === 'function') {
                            doneCallback();
                        }

                        var currentZoom = this._model.map.getZoom();

                        // By default, fetch POI if only one ride is present
                        if (this._model.type === globalMap.type.RIDE &&
                            this._model.rideIds.length === 1 &&
                            currentZoom >= this._model.zoomPolyline
                        ) {
                            setTimeout(function () {
                                if (this._model.ridesData.length && this._model.ridesData[0].poisCount > 0) {
                                    this.fetchPOI(this._model.rideIds.first());
                                }
                            }.bind(this), 200);
                        } else {
                            this._clearPoiMarkers();
                        }

                        // Fetch affiliated shops in adatped mode
                        if ((this._model.mode === globalMap.mode.AFFILIATED ||
                                this._model.mode === globalMap.mode.AFFILIATING) &&
                            this._model.type === globalMap.type.RIDE) {
                            setTimeout(function () {
                                this.fetchShops({affiliateToRides: this._model.rideIds});
                            }.bind(this), 400);
                        }

                        // Fetch tourist offices
                        setTimeout(function () {
                            this.fetchTouristOffice(this._model.rideIds.first());
                        }.bind(this), 600);
                    }.bind(this));
                } else {
                    this.fetchRides(options, function () {
                        if (typeof (doneCallback) === 'function') {
                            doneCallback();
                        }
                    }.bind(this));
                }
            } else if (this._model.type === globalMap.type.POI) {
                if (Utils.isEmpty(this._model.poisData)) {
                    return;
                }

                var rideId = this._model.poisData.map(function (poi) {
                    return poi['rideId'];
                })
                    .uniq();
                if (rideId.length > 1) {
                    console.error('Global map: can only display POIs from one ride: ' + rideId);
                }
                rideId = rideId[0];

                this._model.poiData[rideId] = this._model.poisData;
                this._model.poiFeatures[rideId] = {};
                this._model.poiFeatures[rideId].markerInfos = [];

                for (var poiIndex = 0; poiIndex < this._model.poiData[rideId].length; poiIndex++) {
                    if (this._model.poiData[rideId][poiIndex].type === 'PoiPoint') {
                        var poiMarkerInfo = new MapInterface.MarkerInfo(
                            L.latLng(this._model.poiData[rideId][poiIndex].latitude, this._model.poiData[rideId][poiIndex].longitude),
                            'poi',
                            this._model.poiData[rideId][poiIndex]
                        );
                        this._model.poiFeatures[rideId].markerInfos.push(poiMarkerInfo);
                    }
                }

                this._drawPois(rideId);

                // Display associated ride
                this.fetchCompleteRides({
                    rideIds: [rideId]
                }, function () {
                    this._clearRideClusterMarkers();
                }.bind(this));

                this._fitMapBounds();
            } else if (this._model.type === globalMap.type.TOURIST_OFFICE) {
                if (Utils.isEmpty(this._model.touristOfficesData)) {
                    return;
                }

                this._model.touristOfficeFeatures.markerInfos = [];

                for (var touristOfficeIndex = 0; touristOfficeIndex < this._model.touristOfficesData.length; touristOfficeIndex++) {
                    var touristOffice = this._model.touristOfficesData[touristOfficeIndex];
                    if (touristOffice.type === 'TouristOfficePoint') {
                        var touristOfficeMarkerInfo = new MapInterface.MarkerInfo(
                            L.latLng(touristOffice.location.latitude, touristOffice.location.longitude),
                            'touristOffice',
                            touristOffice
                        );
                        this._model.touristOfficeFeatures.markerInfos.push(touristOfficeMarkerInfo);
                    }
                }

                this._drawTouristOffices();
                this._fitMapBounds();
            } else if (this._model.type === globalMap.type.SHOP) {
                if (Utils.isPresent(this._model.shopIds)) {
                    options.shopIds = this._model.shopIds;
                }

                if (Utils.isPresent(this._model.filter)) {
                    options.filter = this._model.filter;
                }

                this.fetchShops(options, function () {
                    if ((this._model.mode === globalMap.mode.AFFILIATED ||
                            this._model.mode === globalMap.mode.AFFILIATING) &&
                        this._model.type === globalMap.type.SHOP) {
                        setTimeout(function () {
                            this.fetchRides({affiliateToShops: this._model.shopIds});
                        }.bind(this), 300);
                    }

                    if (typeof (doneCallback) === 'function') {
                        doneCallback();
                    }
                }.bind(this));
            } else if (this._model.type === globalMap.type.SELECTED) {
                this.fetchSelected();
            } else if (this._model.type === globalMap.type.ALL) {
                this.fetchRides();
                this.fetchShops();
            }
        };

        this._onAutocompleteLocation = function () {
            this._model.$locationSearchInput.autoComplete({
                cache: true,
                minChars: 2,
                source: function (query, suggest) {
                    this._model.geocoder.query({
                        query: query,
                        proximity: this._model.map.getCenter(),
                        autocomplete: true,
                        country: 'fr',
                        language: I18n.locale,
                        types: ['region', 'postcode', 'place', 'locality', 'neighborhood', 'address']
                    }, function (error, data) {
                        data = data.results;

                        if (!data || !data.features) {
                            return [];
                        }

                        var features = data.features.map(function (feature) {
                            if (feature.context && feature.context.last().short_code === 'fr') {
                                return feature;
                            } else {
                                return null;
                            }
                        });

                        var items = [];
                        features.compact()
                            .forEach(function (feature) {
                                var item = {
                                    'label': feature.place_name,
                                    'value': feature.place_name,
                                    'bounds': (typeof (feature.bbox) !== 'undefined') ? [[feature.bbox[1], feature.bbox[0]], [feature.bbox[3], feature.bbox[2]]] : null,
                                    'location': [feature.center[1], feature.center[0]]
                                };

                                items.push(item);
                            });

                        suggest(items);
                    });
                }.bind(this),
                renderItem: function (item, query) {
                    query = query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    var re = new RegExp('(' + query.split(' ')
                        .join('|') + ')', 'gi');

                    return '<div class="autocomplete-suggestion" data-selected-bounds="' + JSON.stringify(item.bounds) + '" data-selected-location="' + JSON.stringify(item.location) + '" data-val="' + item.value + '">' + item.label.replace(re, '<b>$1</b>') + '</div>';
                },
                onSelect: function (event, query, item) {
                    this._model.$locationSearchInput.data('selected-bounds', item.data('selected-bounds'));
                    this._model.$locationSearchInput.data('selected-location', item.data('selected-location'));
                    this._goToSearchLocation();
                }.bind(this)
            });
        };

        this._goToSearchLocation = function () {
            var bounds = this._model.$locationSearchInput.data('selected-bounds');
            var selectedLocation = this._model.$locationSearchInput.data('selected-location');
            var lat,
                lng;
            if (Utils.is()
                .isObject(bounds)) {
                bounds = [[bounds._southWest.lat, bounds._southWest.lng], [bounds._northEast.lat, bounds._northEast.lng]];
            }
            if (Utils.is()
                .isObject(selectedLocation)) {
                lat = selectedLocation.lat;
                lng = selectedLocation.lng;
            } else {
                lat = selectedLocation[0];
                lng = selectedLocation[1];
            }

            if (!lat || !lng || !bounds) {
                return;
            }

            // Use search marker or Add a new shop
            if (this._model.useSearchMarker) {
                if (this._model.positionMarker) {
                    this._model.positionMarker.setLatLng([lat, lng]);
                } else {
                    this._model.positionMarker = new L.marker(
                        new L.latLng(lat, lng)
                        // _markerOptions.positionMarker
                    );
                    this._model.positionMarker.addTo(this._model.map);
                }
            }

            if (bounds) {
                this.getMap()
                    .fitBounds(bounds);
            } else if (selectedLocation) {
                this.getMap()
                    .setView(selectedLocation, 15);
            }

            this._model.$locationSearchInput.data('selected-bounds', null);
            this._model.$locationSearchInput.data('selected-location', null);

            // Remove focus from input location for mobile device
            this._model.$locationSearchInput.blur();

            // Load data inside bounds in explore mode
            if ((this._model.mode === globalMap.mode.EXPLORE ||
                this._model.mode === globalMap.mode.CHOROPLETH) && bounds) {
                this._model.mapBounds = bounds;
                this._model.map.closePopup();
                this._model.hasPopup = false;

                if (this._model.hasChoropleth) {
                    this._model.filter = {};
                    this._clearChoropleth();
                }

                this._fetchRequired(function () {
                    this._model.initZoom = true;
                }.bind(this));
            }
        };

        this._onChoroplethAreaClick = function (areaType, areaId, areaName) {
            if (this._model.areaClickCallback) {
                var elements = [];

                if (this._model.rideFeatures.length > 0) {
                    for (var rideIndex = 0; rideIndex < this._model.rideFeatures.length; rideIndex++) {
                        var rideFeature = this._model.rideFeatures[rideIndex];
                        elements.push({
                            type: 'ride',
                            id: rideFeature.rideId,
                            name: rideFeature.name,
                            summary: rideFeature.summary,
                            defaultPicture: rideFeature.defaultPicture,
                            formattedDistance: rideFeature.formattedDistance,
                            formattedDuration: rideFeature.formattedDuration,
                            city: rideFeature.city,
                            link: rideFeature.linkUrl
                        });
                    }
                }

                if (this._model.shopFeatures.length > 0) {
                    for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                        var shopFeature = this._model.shopFeatures[shopIndex];
                        elements.push({
                            type: 'shop',
                            id: shopFeature.shopId,
                            trade: shopFeature.trade,
                            tradeTranslated: I18n.t(`js.shop.enums.trade.${shopFeature.trade}`),
                            name: shopFeature.name,
                            summary: shopFeature.summary,
                            defaultPicture: shopFeature.defaultPicture,
                            city: shopFeature.city,
                            link: shopFeature.linkUrl
                        });
                    }
                }

                this._model.areaClickCallback(areaType, areaId, areaName, elements);
            }
        };

        this._onChoroplethMouseMove = function (type, event) {
            var layer = event.target;

            var globalType = 'rides';
            if (this._model.type === globalMap.type.SHOP) {
                globalType = 'shops';
            }

            this._model.choroplethPopup.setLatLng(event.latlng);
            if (type === 'region') {
                // this._model.choroplethPopup.setContent(
                //     '<div class="choropleth-popup">' + '<div class="choropleth-title">' + layer.feature.properties.nom + '</div>' + '</div>');
                //
                // this._model.regionsLayer.eachLayer(function (regionLayer) {
                //     if (regionLayer._leaflet_id === layer._leaflet_id) {
                //         regionLayer.setStyle(_choroplethOptions.highlightedRegionStyle);
                //     } else {
                //         if (this._model.regionSelected) {
                //             regionLayer.setStyle(_choroplethOptions.inactiveRegionStyle);
                //         } else {
                //             regionLayer.setStyle(_choroplethOptions.defaultRegionStyle);
                //         }
                //     }
                // }.bind(this));
            } else if (type === 'department') {
                // Reset department layers
                this._model.departmentsLayer.eachLayer(function (layer) {
                    var departmentCode = layer.feature.properties.code;
                    layer.setStyle(_choroplethOptions.highlightedDepartmentStyle(this._model.densityByDepartments[departmentCode]));
                }.bind(this));

                // Display pop-up
                var departmentCode = layer.feature.properties.code;
                var choroplethTranslation = 'js.maps.choropleth.count.' + globalType;
                this._model.choroplethPopup.setContent(
                    '<div class="choropleth-popup">' + '<div class="choropleth-title">' + layer.feature.properties.nom + '</div>' + this._model.densityByDepartments[departmentCode] + ' ' + I18n.t(choroplethTranslation) + '</div>');

                layer.setStyle(_choroplethOptions.hoverDepartmentStyle);
            }

            if (!this._model.choroplethPopup._map && !this._model.hasPopup) {
                this._model.choroplethPopup.openOn(this._model.map);
            }

            if (!L.Browser.ie && !L.Browser.opera) {
                layer.bringToFront();
            }
        };

        this._onChoroplethMouseOut = function (type, event) {
            var layer = event.target;

            if (type === 'region') {
                // var regionCode = layer.feature.properties.code;
                //
                // if (this._model.regionSelected) {
                //     layer.setStyle(_choroplethOptions.inactiveRegionStyle);
                // } else {
                //     layer.setStyle(_choroplethOptions.defaultRegionStyle);
                // }
            }

            if (type === 'department') {
                var departmentCode = layer.feature.properties.code;

                // Reset department layers
                this._model.departmentsLayer.eachLayer(function (layer) {
                    var departmentCode = layer.feature.properties.code;
                    layer.setStyle(_choroplethOptions.highlightedDepartmentStyle(this._model.densityByDepartments[departmentCode]));
                }.bind(this));

                // Set overview layer
                if (this._model.departmentSelected) {
                    layer.setStyle(_choroplethOptions.inactiveRegionStyle);
                } else {
                    if (this._model.densityByDepartments) {
                        layer.setStyle(_choroplethOptions.highlightedDepartmentStyle(this._model.densityByDepartments[departmentCode]));
                    } else {
                        layer.setStyle(_choroplethOptions.defaultRegionStyle);
                    }
                }

                if (!this._model.hasPopup) {
                    this._model.map.closePopup();
                }
            }
        };

        this._onChoroplethMouseClick = function (type, layer, callback) {
            // var layer = event.target;

            this._model.map.fitBounds(layer.getBounds());

            this._model.map.closePopup();
            this._model.hasPopup = false;

            if (type === 'region') {
                this._model.regionSelected = layer.feature.properties.code;
                this._model.departmentSelected = null;

                this._model.regionsLayer.eachLayer(function (regionLayer) {
                    if (regionLayer._leaflet_id === layer._leaflet_id) {
                        regionLayer.setStyle({
                            fill: false
                        });
                    } else {
                        regionLayer.setStyle({fill: true});
                        regionLayer.setStyle(_choroplethOptions.inactiveRegionStyle);
                    }
                });

                this._clearRegionNameChoropleth();

                this._model.$placeContainer.show();
                // this._model.$placeContainer.find('.place-location').text(layer.feature.properties.nom);
                this._model.$placeContainer.find('.place-location')
                    .text(I18n.t('js.maps.choropleth.helper.region'));

                this._loadChoroplethDepartments(layer.feature.properties.code, callback);

                this._onChoroplethAreaClick('region', layer.feature.properties.code, layer.feature.properties.nom);
            } else if (type === 'department') {
                if (!this._model.departmentsLayer) {
                    return;
                }

                var departmentName = layer.feature.properties.nom;

                this._model.departmentSelected = layer.feature.properties.code;
                this._model.initZoom = true;
                this._model.mapBounds = null;

                this._model.filter.departmentCode = layer.feature.properties.code;

                this._model.departmentsLayer.eachLayer(function (departmentLayer) {
                    if (departmentLayer._leaflet_id === layer._leaflet_id) {
                        departmentLayer.setStyle({
                            fill: false
                        });
                    } else {
                        departmentLayer.setStyle({fill: true});
                        departmentLayer.setStyle(_choroplethOptions.inactiveRegionStyle);
                    }
                });

                this._model.$placeContainer.find('.place-location')
                    .text(departmentName);

                this._clearAll();

                this._fetchRequired(function () {
                    // this._fitMapBounds();
                    // this._model.mapBounds = null;
                    // this._model.initZoom = true;

                    if (typeof (callback) === 'function') {
                        callback();
                    }

                    this._onChoroplethAreaClick('department', layer.feature.properties.code, layer.feature.properties.nom);
                }.bind(this));
            }
        };

        this._loadChoroplethDepartments = function (regionCode, callback) {
            var globalType = 'rides';
            if (this._model.type === globalMap.type.SHOP) {
                globalType = 'shops';
            }

            if (this._model.departmentsLayer) {
                this._model.map.removeLayer(this._model.departmentsLayer);
            }

            this._model.departmentsLayer = L.mapbox.featureLayer()
                .loadURL(_choroplethOptions.franceDepartmentsByRegionUrl(regionCode))
                .on('ready', function (event) {
                    var featureLayer = event.target;

                    getFetch('/api/' + globalType + '/choropleth', {
                        regionCode: regionCode,
                        filter: this._model.filter
                    })
                        .then(function (choroplethData) {
                            if (!choroplethData) {
                                return;
                            }

                            featureLayer.eachLayer(function (layer) {
                                var departmentCode = layer.feature.properties.code;

                                this._model.densityByDepartments = choroplethData;

                                layer.setStyle(_choroplethOptions.highlightedDepartmentStyle(this._model.densityByDepartments[departmentCode]));

                                layer.on({
                                    mousemove: this._onChoroplethMouseMove.bind(this, 'department'),
                                    mouseout: this._onChoroplethMouseOut.bind(this, 'department'),
                                    click: this._onChoroplethMouseClick.bind(this, 'department', layer)
                                });

                                if (typeof (callback) === 'function') {
                                    callback();
                                }
                            }.bind(this));
                        }.bind(this));
                }.bind(this))
                .addTo(this._model.map);
        };

        this._loadChoroplethRegions = function () {
            this._model.regionsLayer = L.mapbox.featureLayer()
                .loadURL(_choroplethOptions.franceRegionsUrl)
                .on('ready', function (event) {
                    var featureLayer = event.target;
                    featureLayer.eachLayer(function (layer) {
                        layer.setStyle(_choroplethOptions.defaultRegionStyle);

                        this._addRegionNameChoropleth(layer);

                        layer.on({
                            // mousemove: this._onChoroplethMouseMove.bind(this, 'region'),
                            // mouseout: this._onChoroplethMouseOut.bind(this, 'region'),
                            click: this._onChoroplethMouseClick.bind(this, 'region', layer)
                        });

                        this._model.isChoroplethLoaded = true;
                        this._choroplethLoadedFuncs();

                        this._model.$placeContainer.show();
                        this._model.$placeContainer.find('.place-location')
                            .text(I18n.t('js.maps.choropleth.helper.initial'));
                    }.bind(this));
                }.bind(this))
                .addTo(this._model.map);
        };

        this._addRegionNameChoropleth = function (layer) {
            var regionCenter = layer.getBounds()
                .getCenter();
            var regionNameMarker = new L.marker(regionCenter, _markerOptions.regionNameMarker(layer.feature.properties.nom));
            regionNameMarker.on({
                click: this._onChoroplethMouseClick.bind(this, 'region', layer)
            });
            regionNameMarker.addTo(this._model.map);
            this._model.regionNameMarkers.push(regionNameMarker);
        };

        this._adaptRegionNameChoropleth = function (zoom) {
            if (this._model.regionNameMarkers.length > 0) {
                for (var regionNameIndex = 0; regionNameIndex < this._model.regionNameMarkers.length; regionNameIndex++) {
                    var regionMarker = this._model.regionNameMarkers[regionNameIndex];
                    if (regionMarker) {
                        regionMarker.setIcon(_markerOptions.regionNameMarker(regionMarker.options.icon.options.html, zoom).icon);
                    }
                }
            }
        };

        this._clearRegionNameChoropleth = function () {
            if (this._model.regionNameMarkers.length > 0) {
                for (var regionNameIndex = 0; regionNameIndex < this._model.regionNameMarkers.length; regionNameIndex++) {
                    if (this._model.regionNameMarkers[regionNameIndex]) {
                        this._model.map.removeLayer(this._model.regionNameMarkers[regionNameIndex]);
                    }
                }
            }

            this._model.regionNameMarkers = [];
        };

        this._clearChoropleth = function () {
            this._model.hasChoropleth = false;
            this._model.departmentSelected = null;
            this._model.regionSelected = null;

            this._model.$placeContainer.hide();

            if (this._model.departmentsLayer) {
                this._model.map.removeLayer(this._model.departmentsLayer);
            }

            if (this._model.regionsLayer) {
                this._model.map.removeLayer(this._model.regionsLayer);
            }
        };

        this._initializeChoropleth = function () {
            this._model.hasChoropleth = true;
            this._model.choroplethPopup = new L.Popup({
                closeButton: false,
                autoPan: false,
                offset: [0, -12]
            });

            this._model.map.closePopup();
            this._loadChoroplethRegions();
        };
    }

    /* Public Methods
     ******************** */
    globalMap.initialize = function () {
        if (Utils.isEmpty(this._model.type)) {
            console.error('Type (ride or shop or all) not defined: ' + this._model.type);
            return;
        }

        // if (this._model.type === globalMap.type.SELECTED && (Utils.isEmpty(this._model.rideIds) && Utils.isEmpty(this._model.shopIds) && Utils.isEmpty(this._model.productIds) && Utils.isEmpty(this._model.userId))) {
        //     console.error('Type selected chosen but ride ids and shop ids and user id are empty.');
        //     return;
        // }

        if (Utils.isEmpty(this._model.mapId)) {
            console.error('Set a valid map id: ' + this._model.mapId);
            return;
        }

        if ($('#' + this._model.mapId).length === 0) {
            console.error('Div Map container not found, cannot display map: ' + '#' + this._model.mapId);
            return;
        }

        this._model.storage = 'globalMapBounds';

        // Do not load map for SEO but load associated elements
        if (window.seoMode) {
            var options = {};
            if (this._model.type === globalMap.type.RIDE) {
                if (Utils.isPresent(this._model.rideIds)) {
                    options.rideIds = this._model.rideIds;
                }
                if (Utils.isPresent(this._model.filter)) {
                    options.filter = this._model.filter;
                }

                if (this._model.mode === globalMap.mode.SHOW ||
                    this._model.mode === globalMap.mode.AFFILIATED ||
                    this._model.mode === globalMap.mode.AFFILIATING) {
                    this.fetchCompleteRides(options);
                    this.fetchPOI(this._model.rideIds.first());
                    this.fetchShops({affiliateToRides: this._model.rideIds});
                } else {
                    this.fetchRides(options);
                }
            } else if (this._model.type === globalMap.type.POI) {
                if (Utils.isEmpty(this._model.poisData)) {
                    return;
                }

                var rideId = this._model.poisData.map(function (poi) {
                    return poi['rideId'];
                })
                    .uniq();
                this.fetchCompleteRides({
                    rideIds: [rideId[0]]
                });
            } else if (this._model.type === globalMap.type.SHOP) {
                if ((this._model.mode === globalMap.mode.AFFILIATED ||
                        this._model.mode === globalMap.mode.AFFILIATING) &&
                    this._model.type === globalMap.type.SHOP) {
                    if (Utils.isPresent(this._model.shopIds)) {
                        options.shopIds = this._model.shopIds;
                    }
                    if (Utils.isPresent(this._model.filter)) {
                        options.filter = this._model.filter;
                    }

                    this.fetchShops(options);
                    this.fetchRides({affiliateToShops: this._model.shopIds});
                }
            }

            return;
        }

        this._model.rideClusters = new L.MarkerClusterGroup(_markerClusterOptions.rideClusters);
        this._model.shopClusters = new L.MarkerClusterGroup(_markerClusterOptions.shopCluster);

        var mapPosition = this._getCurrentMapPosition();

        L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

        // Create map
        L.mapbox.accessToken = MapInterface.mapboxAccessToken;
        this._model.map = new L.mapbox.map(this._model.mapId + '-mapbox', null, {
            zoomControl: false,
            minZoom: 5,
            maxZoom: 18,
            center: mapPosition.center,
            zoom: mapPosition.zoom,
            gestureHandling: true
        });

        if (!this._model.map) {
            console.error('Cannot create map !');
            return;
        }

        // Select layer service
        this._model.styleLayer = MapInterface.selectTileLayer()
            .addTo(this._model.map);

        this._model.geocoder = L.mapbox.geocoder('mapbox.places', {
            autocomplete: true,
            country: window.locale,
            types: ['region', 'postcode', 'place', 'locality', 'address']
        });

        // Zoom
        L.control.zoom({position: 'bottomright'})
            .addTo(this._model.map);

        // Map scale
        L.control.scale({imperial: false})
            .addTo(this._model.map);

        // Fullscreen
        L.control.fullscreen({
            position: 'bottomright',
            title: {
                false: I18n.t('js.maps.toolbar.fullscreen.enter'),
                true: I18n.t('js.maps.toolbar.fullscreen.exit')
            }
        })
            .addTo(this._model.map);

        this.showMapAttribution();

        // Clear bounds
        this._model.mapBounds = null;

        // Map controller menu
        this._onMenuClick();
        // this._stopClickPropagation();
        this._onAutocompleteLocation();

        // Map interactions for touch screens
        // if ((this._model.mode !== globalMap.mode.EXPLORE && this._model.mode !== globalMap.type.CHOROPLETH) && this._model.map.tap && window.innerWidth < window.settings.medium_screen) {
        //     this._model.map.isTapActivated = false;
        //     this._model.map.tap.disable();
        //     this._model.map.dragging.disable();
        //     this._model.map.doubleClickZoom.disable();
        // }

        // this._model.styleLayer.on('load', function () {
        // if ((this._model.mode !== globalMap.mode.EXPLORE && this._model.mode !== globalMap.type.CHOROPLETH) && this._model.map.tap && !this._model.map.isTapActivated) {
        //     this._model.map.on('dblclick', function (event) {
        //         this._model.map.isTapActivated = true;
        //         this._model.map.tap.enable();
        //         this._model.map.dragging.enable();
        //         this._model.map.doubleClickZoom.enable();
        //     }.bind(this));
        // }

        // if (this._model.mode === globalMap.mode.EXPLORE) {
        //     if (Utils.isPresent(this._model.initialLocation) && Utils.isPresent(this._model.initialLocation.center)) {
        //         this._showSearchMarker(this._model.initialLat, this._model.initialLong);
        //     }
        // }

        if (this._model.mode === globalMap.mode.NEW) {
            var saveBounds = this._getSavedMapBounds();
            if (!this._model.resetBounds && Utils.isPresent(saveBounds) && saveBounds.isValid()) {
                this._model.mapBounds = saveBounds;
                this._model.map.fitBounds(saveBounds);
            }
        }

        // Set zoom end callbacks
        if (this._model.type === globalMap.type.SELECTED) {
            this._model.map.on('zoomstart', function () {
                this._model.map.closePopup();
                this._model.hasPopup = false;
                this._model.previousZoom = this._model.map.getZoom();
            }.bind(this));

            this._model.map.on('dragstart', function () {
                this._model.map.closePopup();
                this._model.hasPopup = false;
            }.bind(this));

            // Wait for all elements are loaded
            setTimeout(function () {
                this._model.map.on('zoomend', function () {
                    if (!this._model.isAutoZoom && this._isFetchFinished()) {
                        this._updateVisibleMarkers();
                    }
                }.bind(this));
            }.bind(this), 1200);

            // this._model.map.on('moveend', function () {
            //     // Called after map center is changed
            //     if (this._isFetchFinished()) {
            //         this._updateVisibleMarkers({initData: true});
            //     }
            // }.bind(this));

            this._model.map.on('dragend', function () {
                if (this._isFetchFinished()) {
                    this._updateVisibleMarkers();
                }
            }.bind(this));

            this._model.map.on('popupclose', function () {
                this._popupClosed();
            }.bind(this));

            if (Utils.isPresent(this._model.ridesData) ||
                Utils.isPresent(this._model.shopsData)) {
                // Ensure data are displayed on map after loading map
                this.showSelected({
                    isMapSearch: false,
                    ridesData: this._model.ridesData,
                    shopsData: this._model.shopsData,
                    minZoom: 12
                });

                // this._updateVisibleMarkers({initData: true});
            } else {
                this._fetchRequired(function () {
                    this._fitMapBounds();
                    this._model.initZoom = true;
                }.bind(this));
            }
        } else if (this._model.mode === globalMap.mode.CHOROPLETH) {
            this._model.styleLayer.on('ready', function () {
                if (!this._model.hasChoropleth) {
                    setTimeout(function () {
                        this._initializeChoropleth();
                    }.bind(this), 200);
                }
            }.bind(this));

            this._model.map.on('zoomend', function () {
                if (this._model.map.getZoom() < 7) {
                    this._clearAll();

                    if (this._model.hasChoropleth) {
                        this._model.departmentSelected = null;
                        this._model.regionSelected = null;

                        if (this._model.departmentsLayer) {
                            this._model.map.removeLayer(this._model.departmentsLayer);
                        }

                        this._model.$placeContainer.hide();
                        this._model.map.closePopup();

                        this._model.regionsLayer.eachLayer(function (layer) {
                            layer.setStyle({fill: true});
                            layer.setStyle(_choroplethOptions.defaultRegionStyle);

                            this._addRegionNameChoropleth(layer);
                        }.bind(this));
                    } else {
                        // this._initializeChoropleth();
                    }
                }

                this._adaptRegionNameChoropleth(this._model.map.getZoom());

                if (this._model.departmentSelected) {
                    this._model.mapBounds = this._model.map.getBounds();
                    this._saveMapBounds(this._model.mapBounds);

                    if (!this._model.initZoom) {
                        this._fetchRequired();
                    }
                    this._model.initZoom = false;
                }
            }.bind(this));

            this._model.map.on('dragend', function () {
                if (this._model.departmentSelected) {
                    this._model.mapBounds = this._model.map.getBounds();
                    this._saveMapBounds(this._model.mapBounds);

                    this._fetchRequired();
                }
            }.bind(this));
        } else {
            this._fetchRequired(function () {
                if (this._model.type === globalMap.type.RIDE) {
                    this._model.map.on('zoomend', function () {
                        this._drawDirectionArrows();
                    }.bind(this));
                }

                this._fitMapBounds();
                this._model.initZoom = true;
            }.bind(this));
        }
        // }.bind(this));
    };

    globalMap.fetchRides = function (params, doneCallback) {
        this._model.hasRideData = false;

        var requestParam = {};
        requestParam.force_locale = window.locale;
        var {
            filter,
            rideIds,
            ...mapParams
        } = (params || {});
        requestParam.map = mapParams || {};
        requestParam.filter = {};

        if (Utils.isPresent(this._model.mapBounds)) {
            requestParam.map.bounds = JSON.stringify(this._model.mapBounds.pad(0.2));
        }
        if (this._model.mode === globalMap.mode.AFFILIATING) {
            requestParam.map.affiliating = true;
        }
        if (params && Utils.isPresent(params.filter)) {
            requestParam.filter = params.filter;
        }
        if (params && Utils.isPresent(params.rideIds)) {
            requestParam.filter.rideIds = params.rideIds;
        }

        getFetch('/api/rides/tracks', requestParam, true)
            .then(function (ridesData) {
                if (!ridesData) {
                    return;
                }

                this._model.ridesData = ridesData.rides;

                if (!this._model.ridesData) {
                    return;
                }

                this._model.hasRideData = true;

                if (Utils.isEmpty(this._model.ridesData)) {
                    // No points to display on map
                    if (this._model.rideFeatures.length > 0) {
                        this._clearTracks();
                        this._clearRideClusterMarkers();
                    }
                } else {
                    // Draw data
                    this._drawTracksAndMarkers({secondary: this._model.type === globalMap.type.SHOP});

                    if (params && params.affiliateToShops) {
                        this._updateAffiliatedElements('ride');
                    }
                }

                if (typeof (doneCallback) === 'function') {
                    doneCallback();
                }
            }.bind(this));
    };

    globalMap.fetchCompleteRides = function (params, doneCallback) {
        this._model.hasRideData = false;

        var requestParam = {};
        requestParam.force_locale = window.locale;
        requestParam.filter = {};

        if (params && Utils.isPresent(params.rideIds)) {
            requestParam.filter.rideIds = params.rideIds;
        }

        getFetch('/api/rides/complete_tracks', requestParam, true)
            .then(function (ridesData) {
                if (!ridesData || !ridesData.rides) {
                    return;
                }

                this._model.updatedRideIds = [];
                ridesData.rides.forEach(function (newRide) {
                    this._model.ridesData = this._model.ridesData.replaceOrAdd('rideId', newRide);

                    this._model.hasRideData = true;

                    if (params && params.update &&
                        (this._model.mode === globalMap.mode.EXPLORE ||
                            this._model.mode === globalMap.mode.CHOROPLETH ||
                            this._model.mode === globalMap.mode.AFFILIATING)) {
                        this._model.updatedRideIds.push(newRide.rideId);
                    }
                }.bind(this));

                if (window.seoMode) {
                    return;
                }

                // Draw data
                this._drawTracksAndMarkers();

                if (typeof (doneCallback) === 'function') {
                    doneCallback();
                }
            }.bind(this));
    };

    globalMap.fetchPOI = function (rideId) {
        var requestParam = {
            force_locale: window.locale,
            map: {}
        };

        getFetch('/api/rides/' + rideId + '/points-of-interest', requestParam, true)
            .then(function (poiData) {
                if (!poiData || !poiData.pois) {
                    return;
                }

                this._model.poiData[rideId] = poiData.pois;

                if (Utils.isEmpty(this._model.poiData[rideId]) || Utils.isEmpty(this._model.ridesData)) {
                    return;
                }

                var rideIds = this._model.ridesData.map(function (ride) {
                    return ride['rideId'];
                });
                if (Utils.isPresent(rideIds) && rideIds.includes(rideId)) {
                    if (!this._model.poiFeatures[rideId]) {
                        this._model.poiFeatures[rideId] = {};
                    }
                    this._model.poiFeatures[rideId].markerInfos = [];

                    for (var i = 0; i < this._model.poiData[rideId].length; i++) {
                        if (this._model.poiData[rideId][i].type === 'PoiPoint') {
                            var markerInfo = new MapInterface.MarkerInfo(
                                L.latLng(this._model.poiData[rideId][i].latitude, this._model.poiData[rideId][i].longitude),
                                'poi',
                                this._model.poiData[rideId][i]
                            );
                            this._model.poiFeatures[rideId].markerInfos.push(markerInfo);
                        }
                    }

                    this._poiLoadedFuncs(rideId, this._model.poiData[rideId]);

                    if (window.seoMode) {
                        return;
                    }

                    this._drawPois(rideId);
                    this._fitMapBounds();
                }
            }.bind(this));
    };

    globalMap.fetchShops = function (params, doneCallback) {
        this._model.hasShopData = false;

        const {
            filter,
            shopIds,
            ...mapParams
        } = (params || {});
        var requestParam = {
            force_locale: window.locale,
            map: mapParams,
            filter: {}
        };

        if (Utils.isPresent(this._model.mapBounds)) {
            requestParam.map.bounds = JSON.stringify(this._model.mapBounds.pad(0.2));
        }
        if (this._model.mode === globalMap.mode.AFFILIATING) {
            requestParam.map.affiliating = true;
        }
        if (params && Utils.isPresent(params.filter)) {
            requestParam.filter = params.filter;
        }
        if (params && Utils.isPresent(params.shopIds)) {
            requestParam.filter.shopIds = params.shopIds;
        }

        $.getJSON(
            '/api/shops/map_locations.json',
            requestParam)
            .done(function (shopsData) {
                this._model.shopsData = shopsData.shops;

                this._model.hasShopData = true;

                if (Utils.isEmpty(this._model.shopsData)) {
                    // No shops to display on map
                    if (this._model.shopFeatures.length > 0) {
                        this._clearShops();
                    }

                    this._fitMapBounds();
                } else {
                    this._drawShops({secondary: this._model.type === globalMap.type.RIDE});

                    if (params && params.affiliateToRides) {
                        this._updateAffiliatedElements('shop');
                    }
                }

                if (typeof (doneCallback) === 'function') {
                    doneCallback();
                }
            }.bind(this));
    };

    globalMap.fetchTouristOffice = function (rideId) {
        if (!this._model.mapBounds) {
            return;
        }

        var requestParam = {
            force_locale: window.locale,
            map: {
                bounds: JSON.stringify(this._model.mapBounds.pad(2))
            }
        };

        $.getJSON(
            '/api/tourist-offices/map_locations.json',
            requestParam)
            .done(function (touristOfficeData) {
                this._model.touristOfficesData = touristOfficeData.touristOffices;

                if (Utils.isEmpty(this._model.touristOfficesData)) {
                    return;
                }

                this._model.touristOfficeFeatures.markerInfos = [];

                for (var touristOfficeIndex = 0; touristOfficeIndex < this._model.touristOfficesData.length; touristOfficeIndex++) {
                    var touristOffice = this._model.touristOfficesData[touristOfficeIndex];
                    if (touristOffice.type === 'TouristOfficePoint') {
                        var touristOfficeMarkerInfo = new MapInterface.MarkerInfo(
                            L.latLng(touristOffice.location.latitude, touristOffice.location.longitude),
                            'touristOffice',
                            touristOffice
                        );
                        this._model.touristOfficeFeatures.markerInfos.push(touristOfficeMarkerInfo);
                    }
                }

                this._drawTouristOffices();
            }.bind(this));
    };

    globalMap.fetchSelected = function (options) {
        if (options) {
            this._model.rideIds = [];
            this._model.shopIds = [];
            this._model.productIds = [];
            this._clearAll();
        }

        if (options && Utils.isPresent(options.rideIds)) {
            this._model.rideIds = options.rideIds;
        }

        if (options && Utils.isPresent(options.shopIds)) {
            this._model.shopIds = options.shopIds;
        }

        if (options && Utils.isPresent(options.productIds)) {
            this._model.productIds = options.productIds;
        }

        if (options && Utils.isPresent(options.userId)) {
            this._model.userId = options.userId;
        }

        if (options && Utils.isPresent(options.filter)) {
            this._model.filter = options.filter;
        }

        if (options && typeof options.includeBounds !== 'undefined') {
            this._model.includeBounds = options.includeBounds;
        }

        if (options && options.clearBounds) {
            this._model.mapBounds = null;
        }

        if (Utils.isPresent(this._model.rideIds)) {
            this.fetchRides({rideIds: this._model.rideIds}, function () {
                this._fitMapBoundsByMode();
            }.bind(this));
        }

        if (Utils.isPresent(this._model.shopIds)) {
            this.fetchShops({shopIds: this._model.shopIds}, function () {
                this._fitMapBoundsByMode();
            }.bind(this));
        }

        if (Utils.isPresent(this._model.productIds)) {
            this.fetchShops({filter: {productIds: this._model.productIds}}, function () {
                this._fitMapBoundsByMode();
            }.bind(this));
        }

        if (Utils.isPresent(this._model.userId)) {
            if (this._model.filter.ride !== false) {
                this.fetchRides({filter: {userId: this._model.userId}}, function () {
                    this._fitMapBoundsByMode();
                }.bind(this));
            }

            if (this._model.filter.shop !== false) {
                this.fetchShops({filter: {userId: this._model.userId}}, function () {
                    this._fitMapBoundsByMode();
                }.bind(this));
            }
        }

        if (this._model.includeBounds && Utils.isEmpty(this._model.rideIds) && Utils.isEmpty(this._model.shopIds) && Utils.isEmpty(this._model.productIds) && Utils.isEmpty(this._model.userId)) {
            this._fitMapBounds();
        }
    };

    globalMap.showSelected = function (options) {
        if (Utils.isPresent(options.filter)) {
            this._model.filter = options.filter;
        }

        if (typeof options.includeBounds !== 'undefined') {
            this._model.includeBounds = options.includeBounds;
        }

        if (options.clearBounds) {
            this._model.mapBounds = null;
        }

        if (options.minZoom) {
            this._model.minZoom = options.minZoom;
        }

        var ridesDataDifference = [];
        var shopsDataDifference = [];

        if (options.ridesData && options.ridesData.length > 0) {
            ridesDataDifference = options.ridesData.map((ride) => ride.id)
                .filter((rideId) => this._model.ridesData.map((ride) => ride.id)
                    .indexOf(rideId) === -1);

            this._model.ridesData = options.ridesData;
        } else {
            this._clearRideClusterMarkers();
            this._clearTracks();
            this._model.rideIds = [];
            this._model.ridesData = [];
            this._model.rideFeatures = [];
        }

        if (Utils.isPresent(this._model.ridesData)) {
            this._model.hasRideData = true;

            // Draw data
            this._drawTracksAndMarkers();
        }

        if (options.shopsData && options.shopsData.length > 0) {
            ridesDataDifference = options.shopsData.map((shop) => shop.id)
                .filter((shopId) => this._model.shopsData.map((shop) => shop.id)
                    .indexOf(shopId) === -1);

            this._model.shopsData = options.shopsData;
        } else {
            this._clearShops();
            this._model.shopIds = [];
            this._model.productIds = [];
            this._model.shopsData = [];
            this._model.shopFeatures = [];
        }

        if (Utils.isPresent(this._model.shopsData)) {
            this._model.hasShopData = true;

            this._drawShops({secondary: this._model.type === globalMap.type.RIDE});
        }

        if (!options.isMapSearch && (ridesDataDifference.length || shopsDataDifference.length || !this._model.mapBounds)) {
            this._fitMapBoundsByMode();
        }

        // Ensure map has finish fitting bounds
        setTimeout(function () {
            this._updateVisibleMarkers({initData: true});
        }.bind(this), 300);
    };

    globalMap.onMarkerClicked = function (f) {
        this._model.markerClicked.push(f);
    };

    globalMap.onMarkerLinkClicked = function (f) {
        this._model.markerLinkClicked.push(f);
    };

    globalMap.onVisibleMarkersChanged = function (visibleMarkerCallback) {
        if (typeof (visibleMarkerCallback) !== 'function') {
            return;
        }

        this._model.visibleMarkerCallback = visibleMarkerCallback;
    };

    globalMap.onExploreSearched = function (exploreSearched) {
        if (typeof (exploreSearched) !== 'function') {
            return;
        }

        this._model.exploreSearched = exploreSearched;
    };

    globalMap.onPopupClose = function (popupCloseCallback) {
        if (typeof (popupCloseCallback) !== 'function') {
            return;
        }

        this._model.popupCloseCallback = popupCloseCallback;
    };

    globalMap.onAffiliatedChanged = function (affiliatedCallback) {
        if (typeof (affiliatedCallback) !== 'function') {
            return;
        }

        this._model.affiliatedCallback = affiliatedCallback;
    };

    globalMap.onPoiLoaded = function (f) {
        this._model.poiLoaded.push(f);
    };

    globalMap.onPoiImageClicked = function (f) {
        this._model.poiImageClicked.push(f);
    };

    globalMap.onChoroplethLoaded = function (f) {
        this._model.choroplethLoaded.push(f);
    };

    globalMap.onAreaClick = function (areaClickCallback) {
        if (typeof (areaClickCallback) !== 'function') {
            return;
        }

        this._model.areaClickCallback = areaClickCallback;
    };

    globalMap.onGeolocationFound = function (f) {
        this._model.geolocationFound.push(f);
    };

    globalMap.showMapAttribution = function () {
        if (this._model.map.tap && window.innerWidth < window.settings.small_screen) {
            $('#' + this._model.mapId + ' .leaflet-control-attribution.leaflet-control')
                .addClass('leaflet-compact-attribution');
        } else {
            $('#' + this._model.mapId + ' .leaflet-control-attribution.leaflet-control')
                .removeClass('leaflet-compact-attribution');
        }
    };

    globalMap.getMap = function () {
        return this._model.map;
    };

    globalMap.refreshMap = function () {
        if (Utils.isPresent(this._model.map)) {
            setTimeout(function () {
                this._model.map.invalidateSize();
                this.showMapAttribution();

                this._model.mapBounds = null;
                this._fitMapBoundsByMode();
            }.bind(this), 200);
        }
    };

    globalMap.centerOnRegionChoropleth = function (pointInRegion) {
        if (this._model.mode === globalMap.mode.CHOROPLETH && this._model.isChoroplethLoaded) {
            var regionLayerMarker = leafletPip.pointInLayer(pointInRegion, this._model.regionsLayer, true);

            if (regionLayerMarker[0]) {
                this._onChoroplethMouseClick('region', regionLayerMarker[0]);
            }
        }
    };

    globalMap.centerOnDepartmentChoropleth = function (pointInDepartment) {
        if (this._model.mode === globalMap.mode.CHOROPLETH && this._model.isChoroplethLoaded) {
            var regionLayerMarker = leafletPip.pointInLayer(pointInDepartment.slice()
                .reverse(), this._model.regionsLayer, true);
            if (regionLayerMarker[0]) {
                this._onChoroplethMouseClick('region', regionLayerMarker[0], function () {
                    var departmentLayerMarker = leafletPip.pointInLayer(pointInDepartment.slice()
                        .reverse(), this._model.departmentsLayer, true);

                    if (departmentLayerMarker[0]) {
                        this._onChoroplethMouseClick('department', departmentLayerMarker[0]);
                    }
                }.bind(this));
            }
        }
    };

    globalMap.onGeolocation = function () {
        Notification.alert(I18n.t('js.maps.geolocation.in_progress'));

        Geolocation.geolocate(function (mode, positionLocated) {
            if (mode === 'position' && positionLocated) {
                this._model.$followMeButton.on('click', function () {
                    this.onTrackGeolocation();
                    this._model.$followMeButton.hide();
                }.bind(this));
                this._model.$followMeButton.show();

                if (this._model.positionMarker) {
                    this._model.positionMarker.setLatLng([positionLocated.latitude, positionLocated.longitude]);
                } else {
                    this._model.positionMarker = new L.marker(
                        new L.latLng(positionLocated.latitude, positionLocated.longitude),
                        _markerOptions.positionMarker
                    );

                    this._model.positionMarker.addTo(this._model.map);
                }

                if (this._model.mode === globalMap.mode.CHOROPLETH) {
                    var regionLayerMarker = leafletPip.pointInLayer(this._model.positionMarker.getLatLng(), this._model.regionsLayer, true);

                    if (regionLayerMarker[0]) {
                        this._onChoroplethMouseClick('region', regionLayerMarker[0], function () {
                            var departmentLayerMarker = leafletPip.pointInLayer(this._model.positionMarker.getLatLng(), this._model.departmentsLayer, true);
                            if (departmentLayerMarker[0]) {
                                this._onChoroplethMouseClick('department', departmentLayerMarker[0]);
                            }
                        }.bind(this));
                    }
                } else if (this._model.mode === globalMap.mode.AFFILIATED) {
                    this._model.mapBounds = new L.LatLngBounds().extend(this._model.positionMarker._latlng);
                    this._model.map.flyTo(this._model.positionMarker._latlng);
                    // this._fitMapBounds();
                } else {
                    this._model.mapBounds = new L.LatLngBounds().extend(this._model.positionMarker._latlng);
                    this._model.map.flyTo(this._model.positionMarker._latlng, 14);
                }
            }

            this._geolocatedFuncs(mode, positionLocated);
        }.bind(this), {
            map: this._model.map,
            setView: this._model.mode === globalMap.mode.CHOROPLETH,
            maxZoom: 15
        });
    };

    globalMap.onTrackGeolocation = function () {
        if (this._model.type === globalMap.type.RIDE && this._model.rideFeatures.length === 1) {
            var rideId = this._model.rideFeatures[0].rideId;

            if (this._model.positionMarker) {
                this._model.map.removeLayer(this._model.positionMarker);
                this._model.positionMarker = null;
            }
            if (this._model.directionMarker) {
                this._model.map.removeLayer(this._model.directionMarker);
                this._model.directionMarker = null;
            }

            this.trackDeviceOrientation();

            this._model.map.closePopup();
            this._model.hasPopup = false;
            var poiIdOpen = null;
            var poiMarkerOpen = null;

            // Disable double touch and set to full screen
            this._model.map.gestureHandling.disable();
            if (!this._model.map.isFullscreen()) {
                try {
                    this._model.map.toggleFullscreen();
                } catch (e) {
                    // ignore
                }
            }

            Geolocation.geolocate(function (mode, positionLocated) {
                if (mode === 'tracking' && positionLocated) {
                    if (!this._model.trackPositionMarker) {
                        this._model.trackPositionMarker = new L.marker(
                            new L.latLng(positionLocated.latitude, positionLocated.longitude),
                            _markerOptions.trackPositionMarker(0)
                        );
                        this._model.trackPositionMarker.addTo(this._model.map);
                        this._geolocatedFuncs(mode, positionLocated);
                        this._model.mapBounds = null;
                        this._fitMapBounds();

                        this._model.trackPositionMarker.off('click')
                            .on(
                                'click touchend',
                                function () {
                                    this._model.positionMarkerAngle += 90;

                                    if (this._model.positionMarkerAngle > 360) {
                                        this._model.positionMarkerAngle = 0;
                                    }
                                }.bind(this)
                            );
                    } else {
                        this._model.trackPositionMarker.setLatLng([positionLocated.latitude, positionLocated.longitude]);

                        if (!!this._model.poiFeatures[rideId]) {
                            // Open POI when user is nearby
                            for (var poiIndex = 0; poiIndex < this._model.poiFeatures[rideId].markerPoints.length; poiIndex++) {
                                var poiId = this._model.poiFeatures[rideId].markerPoints[poiIndex].markerId;
                                var poiLatLng = this._model.poiFeatures[rideId].markerInfos[poiIndex].latLng;
                                var poiMarker = this._model.poiFeatures[rideId].markerPoints[poiIndex].marker;

                                var distanceUserToPOI = MapInterface.distHaversine({
                                    lat: positionLocated.latitude,
                                    lng: positionLocated.longitude
                                }, poiLatLng);

                                if (distanceUserToPOI > 30 && !!poiMarkerOpen && poiId === poiIdOpen) {
                                    poiMarkerOpen.closePopup();
                                    poiMarkerOpen = null;
                                    poiIdOpen = null;
                                    this._model.hasPopup = false;
                                }

                                if (distanceUserToPOI < 30 && !poiMarkerOpen) {
                                    poiMarker.openPopup();
                                    poiMarkerOpen = poiMarker;
                                    poiIdOpen = poiId;
                                    this._model.hasPopup = true;
                                }
                            }
                        }
                    }
                }
            }.bind(this), {
                map: this._model.map,
                track: true
                // Do not set view of the map for each update of the user position
                // setView: false,
                // maxZoom: 15
            });
        }
    };

    globalMap.onStopTrackingGeolocation = function () {
        Geolocation.stopGeolocating();

        if (this._model.trackPositionMarker) {
            this._model.map.gestureHandling.enable();

            this._model.map.removeLayer(this._model.trackPositionMarker);
            this._model.trackPositionMarker = null;
        }
    };

    globalMap.trackDeviceOrientation = function () {
        Geolocation.deviceOrientation(function (rotation) {
            if (this._model.trackPositionMarker) {
                this._model.trackPositionMarker.setIcon(_markerOptions.trackPositionMarker(this._model.positionMarkerAngle + rotation).icon);
            }
        }.bind(this));
    };

    globalMap.animateTrack = function (options) {
        options = options || {};

        if (this._model.type === globalMap.type.RIDE && this._model.rideFeatures.length === 1) {
            var rideId = this._model.rideFeatures[0].rideId;
            var currentTrack = this._model.rideFeatures[0].linePoints;
            if (currentTrack.length < 3) {
                return;
            }

            var animatedCoordinates = [];
            animatedCoordinates.push(currentTrack.first().latLng);

            var distanceSinceLastDirectionArrow = 0;
            // var directionArrowInterval = this._getZoomDictionary(this._model.map.getZoom()).directionArrow;
            var directionArrowInterval = 50;

            var carryoverDistance = 0;
            var lastKeyPointIndex = 0;
            for (var j = 0; j < currentTrack.length; j++) {
                var thisLinePoint,
                    prevLinePoint;
                thisLinePoint = currentTrack[j];
                var distanceBetween = 0;
                if (j > 0) {
                    prevLinePoint = currentTrack[j - 1];
                    distanceBetween = MapInterface.distHaversine(prevLinePoint.latLng, thisLinePoint.latLng);
                    distanceSinceLastDirectionArrow += distanceBetween;
                }

                var directionArrowsToPlace = 0;
                if (distanceSinceLastDirectionArrow > directionArrowInterval) {
                    directionArrowsToPlace = Math.floor(distanceSinceLastDirectionArrow / directionArrowInterval);
                }

                if (directionArrowsToPlace > 0) {
                    for (var k = 1; k <= directionArrowsToPlace; k++) {
                        var directionArrowLat,
                            directionArrowLng;
                        var distanceToNextDirectionArrow = (directionArrowInterval * k) - carryoverDistance;
                        var percentageBetweenPoints = distanceToNextDirectionArrow / distanceBetween;

                        directionArrowLat = prevLinePoint.latLng.lat + ((thisLinePoint.latLng.lat - prevLinePoint.latLng.lat) * percentageBetweenPoints);
                        directionArrowLng = prevLinePoint.latLng.lng + ((thisLinePoint.latLng.lng - prevLinePoint.latLng.lng) * percentageBetweenPoints);

                        animatedCoordinates.push({
                            lat: directionArrowLat,
                            lng: directionArrowLng
                        });

                        if (k === directionArrowsToPlace) {
                            carryoverDistance = distanceBetween - (percentageBetweenPoints * distanceBetween);
                            distanceSinceLastDirectionArrow = carryoverDistance;
                        }
                    }
                } else {
                    carryoverDistance += distanceBetween;
                }

                if (thisLinePoint.keyPoint !== null) {
                    lastKeyPointIndex = j;
                }
            }

            animatedCoordinates.push(currentTrack.last().latLng);

            this._model.animationMarker = new L.marker(
                [0, 0],
                {
                    icon: L.mapbox.marker.icon({
                        'marker-color': '#f86767'
                    })
                }
            );
            this._model.animationMarker.addTo(this._model.map);

            var t = 0;
            var poiIdOpen = null;
            var poiMarkerOpen = null;
            var animateTrackTick = function () {
                this._model.animationMarker.setLatLng(L.latLng(animatedCoordinates[t]));

                if (options.showPOI && !!this._model.poiFeatures[rideId]) {
                    for (var poiIndex = 0; poiIndex < this._model.poiFeatures[rideId].markerPoints.length; poiIndex++) {
                        var poiId = this._model.poiFeatures[rideId].markerPoints[poiIndex].markerId;
                        var poiLatLng = this._model.poiFeatures[rideId].markerInfos[poiIndex].latLng;
                        var poiMarker = this._model.poiFeatures[rideId].markerPoints[poiIndex].marker;

                        distanceBetween = MapInterface.distHaversine(animatedCoordinates[t], poiLatLng);
                        if (distanceBetween < 30 && !poiMarkerOpen) {
                            poiMarker.openPopup();
                            poiMarkerOpen = poiMarker;
                            poiIdOpen = poiId;
                        } else if (distanceBetween > 30 && !!poiMarkerOpen && poiId === poiIdOpen) {
                            poiMarkerOpen.closePopup();
                            poiMarkerOpen = null;
                            poiIdOpen = null;
                        }
                    }
                }

                if (++t < animatedCoordinates.length) {
                    setTimeout(animateTrackTick, 350);
                } else {
                    this._model.map.removeLayer(this._model.animationMarker);
                }
            }.bind(this);
            animateTrackTick();
        }
    };

    globalMap.highlightMarker = function (type, markerId, cancel) {
        if (type === 'ride' && this._model.rideFeatures.length > 0) {
            for (var trackIndex = 0; trackIndex < this._model.rideFeatures.length; trackIndex++) {
                var rideId = this._model.rideFeatures[trackIndex].rideId;
                var startMarker = this._model.rideFeatures[trackIndex].startMarker;
                if (!startMarker) {
                    continue;
                }

                if (markerId === rideId) {
                    if (cancel) {
                        // if ('unspiderfy' in startMarker.__parent &&
                        //     startMarker.__parent.getChildCount() !== this._model.rideClusters.getLayers().length) {
                        //     startMarker.__parent.unspiderfy();
                        // }

                        startMarker.closePopup();
                    } else {
                        // if ('spiderfy' in startMarker.__parent &&
                        //     startMarker.__parent.getChildCount() !== this._model.rideClusters.getLayers().length) {
                        //     startMarker.__parent.spiderfy();
                        // }

                        startMarker.openPopup();
                    }
                }
            }
        } else if (type === 'shop' && this._model.shopFeatures.length > 0) {
            for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                var shopId = this._model.shopFeatures[shopIndex].shopId;
                var shopMarker = this._model.shopFeatures[shopIndex].shopMarker;
                if (!startMarker) {
                    continue;
                }

                if (markerId === shopId) {
                    if (cancel) {
                        // if ('unspiderfy' in shopMarker.__parent &&
                        //     shopMarker.__parent.getChildCount() !== this._model.rideClusters.getLayers().length) {
                        //     shopMarker.__parent.unspiderfy();
                        // }

                        shopMarker.closePopup();
                    } else {
                        // if ('spiderfy' in shopMarker.__parent &&
                        //     shopMarker.__parent.getChildCount() !== this._model.rideClusters.getLayers().length) {
                        //     shopMarker.__parent.spiderfy();
                        // }

                        shopMarker.openPopup();
                    }
                }
            }
        }
    };

    globalMap.centerMarker = function (type, markerId, parentMarkerId) {
        if (type === 'ride' && this._model.rideFeatures.length > 0) {
            for (var trackIndex = 0; trackIndex < this._model.rideFeatures.length; trackIndex++) {
                var rideId = this._model.rideFeatures[trackIndex].rideId;
                var startMarker = this._model.rideFeatures[trackIndex].startMarker;

                if (markerId === rideId) {
                    this._model.rideClusters.zoomToShowLayer(startMarker, function (marker) {
                        setTimeout(function () {
                            marker.openPopup();
                        }.bind(this), 150);
                    }.bind(this, startMarker));
                }
            }
        } else if (type === 'shop' && this._model.shopFeatures.length > 0) {
            for (var shopIndex = 0; shopIndex < this._model.shopFeatures.length; shopIndex++) {
                var shopId = this._model.shopFeatures[shopIndex].shopId;
                var shopMarker = this._model.shopFeatures[shopIndex].shopMarker;

                if (markerId === shopId) {
                    this._model.shopClusters.zoomToShowLayer(shopMarker, function (marker) {
                        setTimeout(function () {
                            marker.openPopup();
                        }.bind(this), 150);
                    }.bind(this, shopMarker));
                }
            }
        } else if (type === 'poi' && this._model.poiFeatures[parentMarkerId]) {
            for (var poiIndex = 0; poiIndex < this._model.poiFeatures[parentMarkerId].markerPoints.length; poiIndex++) {
                var poiId = this._model.poiFeatures[parentMarkerId].markerPoints[poiIndex].markerId;
                var poiMarker = this._model.poiFeatures[parentMarkerId].markerPoints[poiIndex].marker;

                if (markerId === poiId) {
                    this._highlightPoi(markerId, parentMarkerId);
                    var poiLatLng = poiMarker._latlng;
                    this._model.map.flyTo(poiLatLng, 17);
                    // poiMarker.openPopup();
                }
            }
        }
    };

    globalMap.highlightPois = function (highlightPoiIds) {
        if (highlightPoiIds) {
            this._model.poiHighlightIds = highlightPoiIds;
        } else {
            this._model.poiHighlightIds = [];
        }

        this._drawPois(this._model.rideIds[0]);
    };

    globalMap.setSelectedMarker = function (type, markerId, isSelected) {
        if (type === 'ride') {
            if (isSelected) {
                this._model.selectedRides.push(markerId);
            } else {
                this._model.selectedRides.remove(markerId);
            }

            this._forceRedrawTracksAndMarkers();
        } else if (type === 'shop') {
            if (isSelected) {
                this._model.selectedShops.push(markerId);
            } else {
                this._model.selectedShops.remove(markerId);
            }

            this._clearShops();
            this._drawShops();
        }
    };

    globalMap.showArea = function (areaType, areaCode) {
        if (!this._model.isChoroplethLoaded) {
            return;
        }

        if (areaType === 'region') {
            this._model.regionsLayer.eachLayer(function (layer) {
                if (layer.feature.properties.code === areaCode) {
                    this._onChoroplethMouseClick('region', layer);
                }
            }.bind(this));
        } else if (areaType === 'department') {
            this._model.departmentsLayer.eachLayer(function (layer) {
                if (layer.feature.properties.code === areaCode) {
                    this._onChoroplethMouseClick('department', layer);
                }
            }.bind(this));
        }
    };

    globalMap.showViewPointAtDistance = function (distance) {
        if (Utils.isEmpty(this._model.pointsByDistanceTraveled)) {
            return;
        }

        var pointDistances = Object.keys(this._model.pointsByDistanceTraveled);

        var distanceKey = Utils.getClosestValue(pointDistances, Math.floor(distance));

        if (!distanceKey && parseFloat(distance) > parseFloat(pointDistances.last())) {
            distanceKey = pointDistances.last();
        }

        var point = this._model.pointsByDistanceTraveled[distanceKey];

        if (point) {
            this.showViewPointAtPoint(point);
        }
    };

    globalMap.showViewPointAtPoint = function (latLng) {
        if (Utils.isPresent(this._model.viewPointMarker)) {
            this._model.viewPointMarker.setLatLng(latLng);
        } else {
            this._model.viewPointMarker = new L.marker(latLng, _markerOptions.viewPointMarker);
            this._model.viewPointMarker.addTo(this._model.map);
        }
    };

    globalMap.removeViewPointMarker = function () {
        if (Utils.isPresent(this._model.viewPointMarker) && Utils.isPresent(this._model.map)) {
            this._model.map.removeLayer(this._model.viewPointMarker);
            this._model.viewPointMarker = null;
        }
    };

    globalMap.importTracks = function (newTracks) {
        if (newTracks && newTracks.length > 0) {
            this._clearAll();

            this._model.ridesData = newTracks;

            var trackIndex;
            var trackPolyline;
            var lineTracksPoints;
            var trackCoord;
            var totalDistance = 0;

            this._model.rideFeatures = [];

            for (trackIndex = 0; trackIndex < newTracks.length; trackIndex++) {
                if (Utils.isEmpty(newTracks[trackIndex])) {
                    continue;
                }

                var currentTrackFeature = {};
                currentTrackFeature.linePoints = [];
                currentTrackFeature.markerLayer = new L.FeatureGroup();
                currentTrackFeature.polylineLayer = null;

                currentTrackFeature.rideId = newTracks[trackIndex].rideId || newTracks[trackIndex].id;
                currentTrackFeature.name = newTracks[trackIndex].name;
                currentTrackFeature.summary = newTracks[trackIndex].summary;
                currentTrackFeature.defaultPicture = newTracks[trackIndex].defaultPicture;
                currentTrackFeature.formattedDistance = newTracks[trackIndex].formattedDistance;
                currentTrackFeature.formattedDuration = newTracks[trackIndex].formattedDuration;
                currentTrackFeature.city = newTracks[trackIndex].city;

                currentTrackFeature.linkUrl = '#';
                currentTrackFeature.linkName = newTracks[trackIndex].filename;

                currentTrackFeature.type = 'hiking';

                trackPolyline = newTracks[trackIndex].coordinates;
                currentTrackFeature.linePoints = [];
                lineTracksPoints = [];
                for (trackCoord = 0; trackCoord < trackPolyline.length; trackCoord++) {
                    totalDistance += trackPolyline[trackCoord].deltaDistance;

                    lineTracksPoints.push(
                        new MapInterface.PointInfo(
                            L.latLng(trackPolyline[trackCoord].latitude, trackPolyline[trackCoord].longitude),
                            0,
                            0,
                            null
                        )
                    );
                }

                currentTrackFeature.distance = parseInt(totalDistance, 10);

                if (lineTracksPoints.length > 0) {
                    currentTrackFeature.linePoints = lineTracksPoints;
                }

                this._model.rideFeatures.push(currentTrackFeature);
            }

            this._redrawMarkers();

            this._redrawTracks();

            this._markerPopup();

            this._fitMapBounds();
        }
    };

    globalMap.type = MapInterface.type;

    globalMap.mode = {
        EXPLORE: 1,
        SHOW: 2,
        AFFILIATED: 3,
        AFFILIATING: 4,
        CHOROPLETH: 5
    };

    return GlobalMap;
})($, MapInterface);

export default GlobalMap;
